import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { card } from 'creditcards';
import { ModalDialog } from 'bookingform';
import DsDropdownList from '../../ds/molecules/DropdownList';
import Select from '../../common/Select';
import Checkbox from '../../common/Checkbox';
import IntlTelInput from '../../common/IntlTelInput';
import FormControl from '../../common/FormControl';
import RoomKeySellingPoints from '../rooms/RoomKeySellingPoints';
import RoomExtras from '../rooms/RoomExtras';
import ConfirmWaitScreen from './ConfirmWaitScreen';
import {
  setShowLastChanceToRegister, setLastChanceRegisterConfirmed,
  LOYALTY_STATUS, setCoinsApplied, setLoggedUser, setMemberInfo, getMemberInfo,
  logout, setCoinsEntered,
} from '../../../actions/Loyalty';
import { showLoyaltyRegisterNow } from '../../../utils';
import withNavigate from '../../../withNavigate'; // Importa el HOC

import {
  bookingConfirm,
  bookingSaveContactInfo,
  checkCustomerValid,
  clearRoomSelection,
  getCountries,
  sendBudgetEmail,
  sendGTMEvents,
  setCurrencies,
  setUserCurrency,
  setAgentCode,
  setAgentSell,
  setRateType,
  setAgentUseCoins,
  validateEmailToEmailValidator,
  DEVICES,
  getBookingDetail,
  setShowEditBookingContactInformation,
  setBookingContactInformationHasBeenEdited,
} from '../../../actions/Booking';
import { setCreatingBooking } from '../../../actions/Session';
import { sendSimpleGAEvent } from '../../../events/Booking';
import { emptyShoppingCart, emptyShoppingCartEvent } from '../../../actions/Cart';
import { getLangValue } from '../../../utils/Generic';
import { CALL_CENTER_ROLE } from '../../../constants';

import CloseIcon from '../../icons/CloseIcon';
import RadioSelectIcon from '../../icons/RadioSelectIcon';

import '../../../static/less/confirmation_form.less';
import BtnBase from '../../ds/molecules/btn/base';
import BudgetBox from '../budget/BudgetBox';
import BudgetForm from '../budget/BudgetForm';

import { store } from '../../../Store';
import '../../../static/less/rooms/client_already_loyalty_member.less';
import EditContactInfoButtons from '../edit-bookings/EditContactInfoButtons';

const sortByOrder = (a, b) => a.order - b.order;
const sortByAlphabet = (a, b) => a.name.localeCompare(b.name);
const countryMapper = (country, lang) =>
  ({ ...country, name: getLangValue(country, lang, 'name') });

const FIELDS = {
  FILL_WITH_USER_DATA: 'fill_with_user_data',
  AGENT_CODE: 'agent_code',
  CLI_NAME: 'cli_name',
  CLI_MIDDLE_NAME: 'cli_middle_name',
  CLI_SURNAME: 'cli_surname',
  CLI_SURNAME2: 'cli_surname2',
  CLI_COUNTRY: 'cli_country',
  CLI_EMAIL: 'cli_email',
  CLI_EMAIL2: 'cli_email2',
  CLI_PHONE: 'cli_phone',
  CLI_POSTAL_CODE: 'cli_postal_code',
  CLI_ADDRESS: 'cli_address',
  CLI_CITY: 'cli_city',
  CLI_CODE: 'cli_code',
  CARD_TYPE: 'card_type',
  CARD_NUMBER: 'card_number',
  CARD_HOLDER: 'card_holder',
  CARD_EXPIRATION_MONTH: 'card_expiration_month',
  CARD_EXPIRATION_YEAR: 'card_expiration_year',
  CARD_CVC: 'card_cvc',
  BOOK_COMMENTS: 'book_comments',
  BOOK_ARRIVAL_TIME: 'book_arrival_time',
  BOOK_CONDITIONS: 'book_conditions',
  BECOME_MEMBER: 'becomeMember',
  ALREADY_MEMBER: 'alreadyMember',
  IS_TRAVEL_AGENT: 'is_travel_agent',
  NEWSLETTER: 'newsletter',
};

class ConfirmForm extends React.Component {
  componentDidMount() {
    // Exponer childFunction a través de forwardedRef
    if (this.props.forwardedRef) {
      this.props.forwardedRef.current = {
        onBookNowClick: this.onBookNowClick,
      };
    }

    if (this.props.locator) {
      this.fillFieldsIsEditingBooking(this.props.locator, this.props.email, this.props.lang);
    }
  }

  validateAgentField = (loyaltyCode) => {
    const { agent_code } = this.state;
    if (!loyaltyCode || loyaltyCode.length === 0) {
      return { ...agent_code, valid: false };
    }
    return { ...agent_code, valid: true };
  };

  validateLoyaltyCode = (loyaltyCode) => {
    const updatedState = { valid: false, msg: this.context.t('Validating...') };

    // We must add a value if its member or agent.
    if (!loyaltyCode || loyaltyCode.length === 0) {
      updatedState.msg = this.context.t('Please enter your {loyalty} Code.', {
        loyalty: this.props.loyaltyName,
      });
      return updatedState;
    }

    // Check if the member code it's valid agains the API.
    this.props.checkCustomerValid(loyaltyCode.trim()).then((r) => {
      updatedState.msg = !r.is_valid ? this.context.t('Not a Valid Code') : '';
      updatedState.valid = r.is_valid;
      this.setState({
        cli_code: { ...this.state.cli_code, ...updatedState },
      });
    });

    // Default return
    return updatedState;
  };

  constructor(props) {
    super(props);

    const { hotel } = props;
    if (!hotel) {
      // on componentWillMount we will redirect the user to the Homepage
      return;
    }
    this.paymentCards = hotel.payment_cards && hotel.payment_cards.length > 0
      ? hotel.payment_cards.sort(sortByOrder) : hotel.payment_cards;
    this.years = [];
    this.yearsAmex = [];
    this.months = [];
    this.confirmFormState = {};
    let currentYear = new Date().getFullYear();
    let currentMonth = 1;
    while (this.years.length < 9) {
      this.years.push({ code: currentYear, name: currentYear });
      currentYear += 1;
    }
    currentYear = new Date().getFullYear();
    while (this.yearsAmex.length < 18) {
      this.yearsAmex.push({ code: currentYear, name: currentYear });
      currentYear += 1;
    }
    while (this.months.length < 12) {
      this.months.push({
        code: currentMonth,
        name: `${currentMonth < 10 ? `0${currentMonth}` : currentMonth}`,
      });
      currentMonth += 1;
    }

    const {
      CLI_NAME,
      CLI_MIDDLE_NAME,
      CLI_SURNAME,
      CLI_SURNAME2,
      CLI_COUNTRY,
      CLI_EMAIL,
      CLI_EMAIL2,
      CLI_PHONE,
      CLI_ADDRESS,
      CLI_CITY,
      CLI_POSTAL_CODE,
      CLI_CODE,
      BOOK_COMMENTS,
      BOOK_ARRIVAL_TIME,
      CARD_TYPE,
      CARD_NUMBER,
      CARD_HOLDER,
      CARD_EXPIRATION_MONTH,
      CARD_EXPIRATION_YEAR,
      CARD_CVC,
      AGENT_CODE,
    } = FIELDS;

    let memberEmail = '';
    if (this.props.loyaltyMemberInfo && this.props.loyaltyMemberInfo.email
      && !(this.props.agentCode !== '' && this.props.agentSell === 'true')) {
      memberEmail = this.props.loyaltyMemberInfo.email;
    }
    this.state = {
      showLoadingRetrieving: false,
      showLoadingSaving: false,
      shouldScrollToWaitingDiv: false,
      waitScreenMode: 'waiting',
      sendPaymentEmail: false, // for Call Center users, to make the users receive an email
      isVisibleTerms: false, // Whether or not the pop-up is visible
      isVisibleBudgetTerms: false, // Whether or not the budget terms pop-up is visible
      isVisibleBudgetModal: false, // Whether or not the pop-up budget form is visible
      isVisibleBudgetSentModal: false, // Whether or not the pop-up budget sent is visible
      budgetSent: false, // Whether or not the budget was sent properly
      bookNow: false,
      fill_with_user_data: {
        value: false,
        valid: false,
        msg: '',
        required: false,
      },
      cli_name: {
        name: CLI_NAME,
        value: '',
        valid: undefined,
        msg: '',
        required: true,
      },
      cli_middle_name: {
        name: CLI_MIDDLE_NAME,
        value: '',
        valid: undefined,
        msg: '',
        required: false,
      },
      cli_surname: {
        // This field is always mandatory, it always refers to the user's surname
        name: CLI_SURNAME,
        value: '',
        valid: undefined,
        msg: '',
        required: true,
      },
      cli_surname2: {
        name: CLI_SURNAME2,
        value: '',
        valid: undefined,
        msg: '',
        required: false,
      },
      cli_country: {
        name: CLI_COUNTRY,
        value: {
          code: '',
          name: '',
        },
        valid: undefined,
        msg: '',
        required: true,
      },
      countries: { options: [], lang: props.lang },
      cli_email: {
        name: CLI_EMAIL,
        value: memberEmail,
        valid: memberEmail ? true : undefined,
        msg: '',
        required: true,
      },
      cli_email2: {
        name: CLI_EMAIL2,
        value: memberEmail,
        valid: memberEmail ? true : undefined,
        msg: '',
        required: true,
      },
      cli_phone: {
        name: CLI_PHONE,
        value: '',
        valid: undefined,
        msg: '',
        required: true,
      },
      cli_address: {
        name: CLI_ADDRESS,
        value: '',
        valid: undefined,
        msg: '',
        required: true,
      },
      cli_city: {
        name: CLI_CITY,
        value: '',
        valid: undefined,
        msg: '',
        required: true,
      },
      cli_postal_code: {
        name: CLI_POSTAL_CODE,
        value: '',
        valid: undefined,
        msg: '',
        required: true,
      },
      cli_code: {
        name: CLI_CODE,
        value: '',
        valid: undefined,
        msg: '',
        required: false,
      },
      agent_code: {
        name: AGENT_CODE,
        value: '',
        valid: undefined,
        msg: '',
        required: false,
        informative: true,
      },
      book_comments: {
        name: BOOK_COMMENTS,
        value: '',
        valid: true,
        msg: '',
        required: false,
      },
      book_arrival_time: {
        name: BOOK_ARRIVAL_TIME,
        value: {
          code: '',
          name: '',
        },
        valid: undefined,
        msg: '',
        required: true,
      },
      book_arrival_times: {
        options: Array.from(Array(24).keys()).map(
          // eslint-disable-next-line prefer-template
          (x) => ({ code: ('0' + x).slice(-2) + ':00', name: ('0' + x).slice(-2) + ':00' })),
        lang: props.lang,
      },
      is_travel_agent: {
        value: false,
        valid: false,
        msg: '',
        required: false,
      },
      showErrorTooltip: false,
      paymentMethod: {
        value: props.paymentMethods[0],
        valid: true,
        msg: '',
        required: true,
      },
      card_type: {
        name: CARD_TYPE,
        value: { code: '' },
        valid: undefined,
        msg: '',
        required: true,
      },
      card_number: {
        name: CARD_NUMBER,
        value: '',
        valid: undefined,
        msg: '',
        required: true,
      },
      card_holder: {
        name: CARD_HOLDER,
        value: '',
        valid: undefined,
        msg: '',
        required: true,
      },
      card_expiration_month: {
        name: CARD_EXPIRATION_MONTH,
        value: {},
        valid: undefined,
        msg: '',
        required: true,
      },
      card_expiration_year: {
        name: CARD_EXPIRATION_YEAR,
        value: {},
        valid: undefined,
        msg: '',
        required: true,
      },
      card_cvc: {
        name: CARD_CVC,
        value: '',
        valid: undefined,
        msg: '',
        required: true,
      },
      book_conditions: {
        value: false,
        valid: false,
        msg: '',
        required: true,
      },
      newsletter: {
        value: this.props.isLoyaltyUserLoggedIn === true ? this.props.optinAccepted : false,
        valid: false,
        msg: '',
        required: false,
      },
      agent_sell_true_client_is_loyalty_member: false, //Bandera usada cuando hay un agentCode y el agente va a vender
      //a otros clientes (agentSell=true). Indica si el cliente es un miembro de loyalty
      showClientIsLoyaltyMember: false,
    };

    // Method bindings
    this.buildIntlCountryOptions = this.buildIntlCountryOptions.bind(this);
    this.clearLoyaltyForm = this.clearLoyaltyForm.bind(this);
    this.createNewBooking = this.createNewBooking.bind(this);
    this.description = this.description.bind(this);
    this.formPreventDefault = this.formPreventDefault.bind(this);
    this.getCountries = this.getCountries.bind(this);
    this.getCurrencies = this.getCurrencies.bind(this);
    this.getDropDownClass = this.getDropDownClass.bind(this);
    this.getExpirationCardDate = this.getExpirationCardDate.bind(this);
    this.getInvalidFieldNames = this.getInvalidFieldNames.bind(this);
    this.getSelectedMethod = this.getSelectedMethod.bind(this);
    this.goBackRooms = this.goBackRooms.bind(this);
    this.hasPaymentMethods = this.hasPaymentMethods.bind(this);
    this.label = this.label.bind(this);
    this.needsCardDetails = this.needsCardDetails.bind(this);
    this.needsCardTypes = this.needsCardTypes.bind(this);
    this.normalizeText = this.normalizeText.bind(this);
    //this.onBookNowClick = this.onBookNowClick.bind(this);
    this.onChangeSelect = this.onChangeSelect.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
    this.onFocusInput = this.onFocusInput.bind(this);
    this.onPhoneBlur = this.onPhoneBlur.bind(this);
    this.onSaveBudget = this.onSaveBudget.bind(this);
    this.renderAgentCodeTemplate = this.renderAgentCodeTemplate.bind(this);
    this.renderAutoFillCheckBox = this.renderAutoFillCheckBox.bind(this);
    this.renderBackButton = this.renderBackButton.bind(this);
    this.renderBookNowButton = this.renderBookNowButton.bind(this);
    this.renderBudgetBox = this.renderBudgetBox.bind(this);
    this.renderBudgetModal = this.renderBudgetModal.bind(this);
    this.renderBudgetTerms = this.renderBudgetTerms.bind(this);
    this.renderCardTypes = this.renderCardTypes.bind(this);
    this.renderForm = this.renderForm.bind(this);
    this.renderOnlinePaymentTip = this.renderOnlinePaymentTip.bind(this);
    this.renderPaymentFields = this.renderPaymentFields.bind(this);
    this.renderPaymentMethodError = this.renderPaymentMethodError.bind(this);
    this.renderPaymentOptions = this.renderPaymentOptions.bind(this);
    this.renderPersonalInfoFields = this.renderPersonalInfoFields.bind(this);
    this.renderPhoneSelector = this.renderPhoneSelector.bind(this);
    this.renderRoomKeyPoints = this.renderRoomKeyPoints.bind(this);
    this.renderRoomExtras = this.renderRoomExtras.bind(this);
    this.renderSecondSurname = this.renderSecondSurname.bind(this);
    this.renderSurname = this.renderSurname.bind(this);
    this.renderTPVFields = this.renderTPVFields.bind(this);
    this.renderTermNewsCheckboxes = this.renderTermNewsCheckboxes.bind(this);
    this.renderTerms = this.renderTerms.bind(this);
    this.renderWaitScreen = this.renderWaitScreen.bind(this);
    this.setCardType = this.setCardType.bind(this);
    this.showErrorMessage = this.showErrorMessage.bind(this);
    this.switchSendPaymentEmail = this.switchSendPaymentEmail.bind(this);
    this.toggleBudgetModal = this.toggleBudgetModal.bind(this);
    this.toggleBudgetSentModal = this.toggleBudgetSentModal.bind(this);
    this.toggleBudgetTermMessages = this.toggleBudgetTermMessages.bind(this);
    this.toggleTermMessages = this.toggleTermMessages.bind(this);
    this.updateFormState = this.updateFormState.bind(this);
    this.validateAgentField = this.validateAgentField.bind(this);
    this.validateConfirmEmail = this.validateConfirmEmail.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.validateExpiryFields = this.validateExpiryFields.bind(this);
    this.validateFormField = this.validateFormField.bind(this);
    this.validateLoyaltyCode = this.validateLoyaltyCode.bind(this);
    this.validateNameFields = this.validateNameFields.bind(this);
    this.validatePhoneNumber = this.validatePhoneNumber.bind(this);
  }

  buildIntlCountryOptions(countryList, lang) {
    let language = lang;
    if (!language) {
      language = this.props.lang;
    }
    const mappedCountries = countryList
      .map((country) => countryMapper(country, language))
      .sort(sortByAlphabet);
    this.setState({ countries: { options: mappedCountries, lang: language } });
  }

  clearLoyaltyForm() {
    const memberInfo = {
      accountHolder: null, email: '', availableCoins: 0, cardCode: '',
    };
    this.props.setMemberInfo(memberInfo);
    this.props.setCoinsApplied(0);
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    const stateForAgentCode = store.getState();
    const agentCodeEnteredInBookingForm = stateForAgentCode.booking.agentCode;
    const agentSellEnteredInBookingForm = stateForAgentCode.booking.agentSell;
    const rateTypeEnteredInBookingForm = stateForAgentCode.bookingFormState.rateType;
    const agentUseCoinsEnteredInBookingForm = stateForAgentCode.bookingFormState.agentUseCoins;

    if (agentCodeEnteredInBookingForm == null) {
      this.props.setAgentCode('');
      stateForAgentCode.bookingFormState.agentCode = '';
    } else {
      stateForAgentCode.bookingFormState.agentCode = agentCodeEnteredInBookingForm;
    }
    if (agentSellEnteredInBookingForm == null) {
      this.props.setAgentSell('false');
      stateForAgentCode.bookingFormState.agentSell = 'false';
    } else {
      stateForAgentCode.bookingFormState.agentSell = agentSellEnteredInBookingForm;
    }
    if (rateTypeEnteredInBookingForm == null) {
      if (stateForAgentCode.booking.rateType != null) {
        stateForAgentCode.bookingFormState.rateType = stateForAgentCode.booking.rateType;
      } else {
        this.props.setRateType('PUBLIC_RATE');
        stateForAgentCode.bookingFormState.rateType = 'PUBLIC_RATE';
        stateForAgentCode.booking.rateType = 'PUBLIC_RATE';
      }
    } else {
      stateForAgentCode.bookingFormState.rateType = rateTypeEnteredInBookingForm;
    }
    // Algunas veces, el campo rateType no viene en booking, pero sí en bookingFormState
    // Entonces buscamos primero en booking y luego en bookingFormState
    if (agentUseCoinsEnteredInBookingForm == null) {
      if (stateForAgentCode.booking.agentUseCoins != null) {
        stateForAgentCode.bookingFormState.agentUseCoins = stateForAgentCode.booking.agentUseCoins;
      } else {
        this.props.setAgentUseCoins('true');
        stateForAgentCode.bookingFormState.agentUseCoins = 'true';
        stateForAgentCode.booking.agentUseCoins = 'true';
      }
    } else {
      stateForAgentCode.bookingFormState.agentUseCoins = agentUseCoinsEnteredInBookingForm;
    }
    if (!this.props.hotel) {
      this.props.navigate('/');
      return;
    }
    // We need to ensure that the countries are loaded
    this.getCountries().then();
    // Evaluate if is a custom currency and set the correct currency
    this.getCurrencies().then();

    if ((agentCodeEnteredInBookingForm === '' && this.props.default_confirm_country)
      || (agentCodeEnteredInBookingForm !== '' && agentSellEnteredInBookingForm === 'true'
      && this.props.default_confirm_country)) {
      // Si no hay agente o si hay agente pero ese agente va a vender reservas a otros clientes
      this.setState({
        cli_country: { ...this.state.cli_country, value: this.props.default_confirm_country },
        cli_phone: { ...this.state.cli_phone, value: `+${this.props.default_confirm_country.dial_code}` },
      });
    }

    if (agentCodeEnteredInBookingForm != null && agentCodeEnteredInBookingForm !== ''
        && agentSellEnteredInBookingForm === 'false') {
      //Sólo si agentSell es false logearemos al agent code en loyalty
      //Es decir, si el agente no va a vender lo podemos logear, pero si el agente
      //está vendiendo a otros clientes, no lo logeamos a ese agente porque puede logear
      //a sus clientes
      this.checkMember(agentCodeEnteredInBookingForm); //Logeamos al agente en loyalty
    }
    if (agentCodeEnteredInBookingForm != null && agentCodeEnteredInBookingForm !== ''
        && agentSellEnteredInBookingForm === 'true') {
      this.checkMember(agentCodeEnteredInBookingForm);
    }
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillUpdate(nextProps) {
    if (nextProps.lang !== this.props.lang) {
      this.buildIntlCountryOptions(
        this.state.countries.options,
        nextProps.lang,
      );
    }
  }

  async createNewBooking() {
    this.setState({ bookNow: true });
    this.props.setCreatingBooking(true);
    // si isEditingBooking mandar el locator
    const result = await this.props.bookingConfirm(this.context,
      this.confirmFormState,
      this.props.navigate,
      this.props.locator,
      this.state.cli_email.value,
    );
    this.props.setCreatingBooking(false);
    if (result === 'ERR') {
      this.setState({ waitScreenMode: 'error' });
    } else {
      // Clearing the selection so that the user does not book twice
      this.props.clearRoomSelection(false); // skip "emptyCartEvent" as emptyShoppingCart sends it
      this.props.emptyShoppingCart();
    }
  }

  async saveBookingContactInformation() {
    this.setState({ showLoadingSaving: true });
    const result = await this.props.bookingSaveContactInfo(this.context,
      this.confirmFormState,
      this.props.navigate,
      this.props.locator,
    );
    this.setState({ showLoadingSaving: false });
    if (result.success === true) {
      this.props.setShowEditBookingContactInformation(false);
      this.props.setBookingContactInformationHasBeenEdited(!this.props.bookingContactInformationHasBeenEdited);
    } else {
      // Hubo un error al guardar los datos de contacto
    }
  }

  description(fieldName) {
    const { AGENT_CODE } = FIELDS;
    switch (fieldName) {
      case AGENT_CODE:
        return this.context.t(
          'Please enter your sandosSMARTagents.com referral code if you are already a member. If not, register now.',
        );
      default:
        return this.context.t('Description');
    }
  }

  formPreventDefault(e) {
    e.preventDefault();
  }

  async getCountries() {
    const countries = await this.props.getCountries();
    if (countries) {
      let allCountries = [];
      if (countries && countries.commons && countries.commons.length > 0) {
        allCountries = countries.commons.concat(countries.not_commons);
      }
      this.buildIntlCountryOptions(allCountries, this.props.lang);
    }
  }

  async getCurrencies() {
    // TEMA VisualicacionTarifasEnDiversasCurrenciesParaCallCenter
    // Se pidió que los usuarios de call center puedan filtrar por varias currencies
    // para ver visualmente los montos. Anteriormente cuando el usuario de call center
    // filtraba por algún currency, también con eso se seteaba ese currency como
    // el payment currency.
    // Pidieron que los usuarios de DIRECTOS CALL CENTER pudieran ver las tarifas en MXN, igual los de DIRECTOS CALL CENTER MÉXICO,
    // que puedan ver las tarifas en cualquier moneda, por lo que se comenta todo el siguiente if
    // De hecho ese if hacía que cuando es call center, en el confirmation form sólo te seteaba las currencies
    // disponibles para filtrar las monedas, te seteaba una sóla, que es la moneda en la que viene el rate en el carrito
    // Quitamos este if siguiente porque no es necesario, al final, la reserva se cobrará en el currency en el
    // que venga el rate en el carrito, pero visualmente dejamos que el usuario filtre por la moneda que quiera
    // para que vea cuánto sería en su moneda que elija, pero al final se cobrará en la moneda en la que venga el rate
    // en el carrito, que es la que se obtuvo al hacer la búsqueda de disponibilidad
    /*if (this.props.isCallCenterUser) {
      const result = this.props.cartHotel.rooms.find(
        (room) => room.rate.currency_code !== this.props.cartHotel.currency.code);
      if (result) {
        const currency = this.props.hotel.currencies.find(
          (currency_item) => currency_item.code === result.rate.currency_code);
        this.props.setCurrencies([currency]);
        this.props.setUserCurrency(currency);
      }
    }*/
  }

  getDropDownClass(field) {
    switch (field.valid) {
      case true:
        return 'valid';
      case false:
        return 'error';
      default:
        return 'default';
    }
  }

  getExpirationCardDate() {
    const year = this.state.card_expiration_year.value.code;
    const month = this.state.card_expiration_month.value.code;
    return `${month}/${year}`;
  }

  getInvalidFieldNames() {
    const fieldsByPassedByIsEditingBooking = [
      FIELDS.CARD_TYPE,
      FIELDS.CARD_NUMBER,
      FIELDS.CARD_HOLDER,
      FIELDS.CARD_EXPIRATION_MONTH,
      FIELDS.CARD_EXPIRATION_YEAR,
      FIELDS.CARD_CVC,
      FIELDS.BOOK_CONDITIONS,
    ];
    const cardRelatedFields = [
      FIELDS.CARD_NUMBER,
      FIELDS.CARD_HOLDER,
      FIELDS.CARD_EXPIRATION_MONTH,
      FIELDS.CARD_EXPIRATION_YEAR,
      FIELDS.CARD_CVC,
    ];

    const isCardRequired = this.hasPaymentMethods() && this.needsCardDetails();
    return Object.keys(this.state).filter((fieldName) => {
      const field = this.state[fieldName];
      if (this.props.locator && fieldsByPassedByIsEditingBooking.indexOf(fieldName) !== -1) {
        // Cuando se está editando la reserva confirmada, no validamos los campos del array fieldsByPassedByIsEditingBooking
        return false;
      }
      if (!isCardRequired && cardRelatedFields.indexOf(fieldName) !== -1) {
        // If the fields are related to the card and we do not need them return false.
        return false;
      }
      if (
        !isCardRequired
              && !this.needsCardTypes()
              && fieldName === FIELDS.CARD_TYPE
      ) {
        return false;
      }
      return !field.valid && field.required;
    });
  }

  getSelectedMethod(paymentMethods) {
    return paymentMethods.find(
      (method) => method.code === this.state.paymentMethod.value.code,
    );
  }

  goBackRooms() {
    sendGTMEvents([{ event: 'LinkClick' }]);
    // The URL to return to depends on which room mode we are currently at
    const roomsPath = this.props.isFreeModeSelected ? '/all-rooms/' : '/rooms/';
    emptyShoppingCartEvent();
    this.props.navigate(roomsPath);
  }

  hasPaymentMethods() {
    return this.props.paymentMethods.length > 0;
  }

  label(fieldName) {
    const {
      FILL_WITH_USER_DATA,
      CLI_NAME,
      CLI_MIDDLE_NAME,
      CLI_SURNAME,
      CLI_SURNAME2,
      CLI_COUNTRY,
      CLI_EMAIL,
      CLI_EMAIL2,
      CLI_PHONE,
      CLI_POSTAL_CODE,
      CLI_ADDRESS,
      CLI_CITY,
      CLI_CODE,
      BOOK_COMMENTS,
      BOOK_ARRIVAL_TIME,
      BOOK_CONDITIONS,
      NEWSLETTER,
      AGENT_CODE,
      CARD_TYPE,
      CARD_NUMBER,
      CARD_HOLDER,
      CARD_CVC,
      CARD_EXPIRATION_MONTH,
      CARD_EXPIRATION_YEAR,
      IS_TRAVEL_AGENT,
    } = FIELDS;
    switch (fieldName) {
      case FILL_WITH_USER_DATA:
        return this.context.t('Same as user registration');
      case CLI_NAME:
        return this.context.t('Name');
      case CLI_MIDDLE_NAME:
        return this.context.t('Middle name');
      case CLI_SURNAME:
        return this.context.t('Last name');
      case CLI_SURNAME2:
        return this.context.t('Second last name');
      case CLI_COUNTRY:
        return this.context.t('Country / Region*');
      case CLI_PHONE:
        return this.context.t('Telephone');
      case CLI_ADDRESS:
        return this.context.t('Address');
      case CLI_CITY:
        return this.context.t('City');
      case CLI_POSTAL_CODE:
        return this.context.t('Zip code');
      case CLI_EMAIL:
        if (this.props.agentCode !== '' && this.props.agentSell === 'true') {
          return this.context.t('Client e-mail address');
        }
        return this.context.t('E-mail address');
      case CLI_EMAIL2:
        if (this.props.agentCode !== '' && this.props.agentSell === 'true') {
          return this.context.t('Confirm client e-mail address');
        }
        return this.context.t('Confirm e-mail address');
      case BOOK_COMMENTS:
        return this.context.t('Comments');
      case BOOK_ARRIVAL_TIME:
        return this.context.t('Estimated arrival time*');
      case CARD_TYPE:
        return this.context.t('Card Type');
      case CARD_NUMBER:
        return this.context.t('Card number');
      case CARD_HOLDER:
        return this.context.t('Card holder');
      case CARD_CVC:
        return this.context.t('CVC');
      case CARD_EXPIRATION_MONTH:
        return this.context.t('Expiry month*');
      case CARD_EXPIRATION_YEAR:
        return this.context.t('Expiry year*');
      case AGENT_CODE:
        return this.context.t('Your sandosSMARTagents.com referral code:');
      case BOOK_CONDITIONS:
        return (
                <span className="acceptTerms">
            {this.context.t('I accept the')}&nbsp;
                  <span onClick={this.toggleTermMessages}>
              {this.context.t('Terms & Conditions')}
            </span>
          </span>
        );
      case CLI_CODE:
        return this.context.t('{loyalty} Code here:', {
          loyalty: this.props.loyaltyName,
        });
      case IS_TRAVEL_AGENT:
        return this.context.t(
          'I am a travel agent booking on behalf of my clients',
        );
      case NEWSLETTER:
        return this.context.t(
          'I want to receive exclusive benefits and news by email',
        );
      default:
        return this.context.t('Name');
    }
  }

  needsCardDetails() {
    return this.state.paymentMethod.value.request_card;
  }

  needsCardTypes() {
    if (!this.hasPaymentMethods()) {
      return undefined;
    }
    return this.state.paymentMethod.value.request_card_type;
  }

  normalizeText(text) {
    // Used for take the text with normalize format.
    return text ? text.trim().toLowerCase() : '';
  }

  onBookNowClick = async (passPopUp = false) => {
    this.props.setLastChanceRegisterConfirmed(false);
    if (showLoyaltyRegisterNow() && passPopUp === false && this.props.isLoyaltyUserLoggedIn === false
      && this.props.selectedStatus !== 'becomeMember' && this.props.agentCode === '') {
      // Pidieron que el pop up de last chance to register no se mostrara cuando hay agentCode
      this.props.setShowLastChanceToRegister(true);
      return;
    }

    // When no valid payment methods exist, the booking can not proceed. A warning message is shown to the user elsewhere
    if (!this.hasPaymentMethods()) {
      return;
    }
    const { cli_email } = this.state;
    if (cli_email.valid === undefined) {
      const fieldValidate = await this.validateFormField(FIELDS.CLI_EMAIL, cli_email.value);
      cli_email.valid = fieldValidate.valid;
      cli_email.msg = fieldValidate.msg;

      this.setState({
        [FIELDS.CLI_EMAIL]: { ...this.state[FIELDS.CLI_EMAIL], ...cli_email },
      });
    }
    // We validate the form. If there are errors, the user can not proceed and we display the invalid fields names
    const invalidFields = this.getInvalidFieldNames();
    if (invalidFields.length > 0) {
      this.setState({ showErrorTooltip: true });
      setTimeout(() => {
        const element = document.querySelector('.ConfirmForm');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 150); // El tiempo en milisegundos puede variar dependiendo de la carga del contenido
      return;
    }

    // Here he have ensured all is OK, so we can proceed to create the new Booking
    this.updateFormState();
    this.createNewBooking().then();
    this.setState({ shouldScrollToWaitingDiv: true });
  }

  saveBookingContactInfo = async () => {
    // Cuando se está editando la reserva flexible confirmada, se permite editar los datos de contacto
    // Entonces esta función manda a llamar a la api para guardar los datos de contacto de la reserva que está siendo editada
    const { cli_email } = this.state;
    if (cli_email.valid === undefined) {
      const fieldValidate = await this.validateFormField(FIELDS.CLI_EMAIL, cli_email.value);
      cli_email.valid = fieldValidate.valid;
      cli_email.msg = fieldValidate.msg;

      this.setState({
        [FIELDS.CLI_EMAIL]: { ...this.state[FIELDS.CLI_EMAIL], ...cli_email },
      });
    }
    // We validate the form. If there are errors, the user can not proceed and we display the invalid fields names
    const invalidFields = this.getInvalidFieldNames();
    if (invalidFields.length > 0) {
      this.setState({ showErrorTooltip: true });
      setTimeout(() => {
        const element = document.querySelector('.ConfirmForm');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 150); // El tiempo en milisegundos puede variar dependiendo de la carga del contenido
      return;
    }

    // Here he have ensured all is OK, so we can proceed to create the new Booking
    this.updateFormState();
    this.saveBookingContactInformation().then();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.lastChanceRegisterConfirmed !== this.props.lastChanceRegisterConfirmed) {
      if (this.props.lastChanceRegisterConfirmed) {
        //console.log('Se debe ejecutar el book now');
        this.onBookNowClick(true);
      } else {
        //console.log('No se debe ejecutar el book now');
      }
    }

    if (prevProps.showLastChanceToRegister !== this.props.showLastChanceToRegister) {
      if (this.props.showLastChanceToRegister) {
        //console.log('El popup de último recordatorio ha sido mostrado.');
        // Aquí puedes agregar la lógica adicional que necesitas cuando el popup se muestra.
      } else {
        //console.log('El popup de último recordatorio ha sido ocultado.');
        // Aquí puedes agregar la lógica que debe suceder cuando el popup es cerrado.
        //this.onBookNowClick(true);
      }
    }

    if (this.state.shouldScrollToWaitingDiv) {
      const element = document.querySelector('.ConfirmForm');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        // Reseteamos el estado para evitar que el scroll se realice en futuras actualizaciones
        this.resetScrollState();
      }
    }
  }

  resetScrollState = () => {
    this.setState({ shouldScrollToWaitingDiv: false });
  }

  onChangeSelect(selectName, selectItem) {
    const isValid = selectItem.code !== ''; // these are required fields
    const { CARD_EXPIRATION_MONTH, CARD_EXPIRATION_YEAR } = FIELDS;
    const statusUpdate = {
      value: selectItem,
      valid: isValid,
      msg: isValid
        ? ''
        : this.context.t('Please select your {fieldName}', {
          fieldName: this.label(selectName),
        }),
    };

    // We'll send the GA event for the select
    sendSimpleGAEvent('abandformcomp', selectName);

    // Additional validations for Select fields
    if (isValid && selectName.indexOf('expiration') !== -1) {
      const fieldValidate = this.validateExpiryFields(selectName, selectItem);
      statusUpdate.valid = fieldValidate.valid;
      statusUpdate.msg = fieldValidate.msg;
      // Clone the result for the other field
      const otherField = selectName === CARD_EXPIRATION_MONTH
        ? CARD_EXPIRATION_YEAR
        : CARD_EXPIRATION_MONTH;
      this.setState({
        [otherField]: {
          ...this.state[otherField],
          valid: statusUpdate.valid,
          msg: statusUpdate.msg,
        },
      });
    }
    this.setState({
      [selectName]: { ...this.state[selectName], ...statusUpdate },
    });
  }

  fill_with_user_data_activate() {
    const { loyaltyUser, lang } = this.props;
    const loyaltyUser2 = { ...loyaltyUser };

    const stateForAgentCode = store.getState();
    const agentCodeEnteredInBookingForm = stateForAgentCode.booking.agentCode;
    const agentSellEnteredInBookingForm = stateForAgentCode.booking.agentSell;

    if (agentCodeEnteredInBookingForm !== '' && stateForAgentCode.loyalty.loggedUser != null
        && agentSellEnteredInBookingForm === 'false') {
      // Si el agente no va a vender a otros clientes es cuando logeamos a ese
      // agente en loyalty y mostramos su país
      loyaltyUser.country = stateForAgentCode.loyalty.loggedUser.country;
    }

    // Si no es un agente mostraremos el seleccionador de países, sino sólo imprimiremos su país y teléfono
    const countryIndex = this.state.countries.options.findIndex(
      (countryOption) => countryOption[`name_${lang}`] === loyaltyUser2.country[`name_${lang}`]);
    loyaltyUser2.country = this.state.countries.options[countryIndex];
    // Update value

    this.setState({
      cli_country: {
        ...this.state.cli_country,
        value: {
          name: loyaltyUser.country ? loyaltyUser.country[`name_${lang}`] : '',
          iso_code: loyaltyUser.country ? loyaltyUser.country.iso_code.toUpperCase() : '',
          valid: true,
        },
      },
    });

    if (loyaltyUser.phone_number && agentCodeEnteredInBookingForm === '') {
      const phoneValue = loyaltyUser.country ? `+${
        loyaltyUser.country.dial_code}${loyaltyUser.phone_number}` : loyaltyUser.phone_number;
      this.setState({
        cli_phone: {
          ...this.state.cli_phone,
          value: phoneValue,
          ...this.validatePhoneNumber(phoneValue),
        },
      });
    }

    if (loyaltyUser.phone_number && agentCodeEnteredInBookingForm !== '') {
      const phoneValue = loyaltyUser.country ? `${loyaltyUser.phone_number}` : loyaltyUser.phone_number;
      this.setState({
        cli_phone: {
          ...this.state.cli_phone,
          value: phoneValue,
          ...this.validatePhoneNumber(phoneValue),
        },
      });
    }

    this.setState({
      cli_name: {
        ...this.state.cli_name,
        value: loyaltyUser.first_name,
        valid: true,
      },
      cli_surname_2: {
        ...this.state.cli_surname_2,
        value: loyaltyUser.middle_name,
        valid: true,
      },
      cli_surname: {
        ...this.state.cli_surname,
        value: loyaltyUser.surname,
        valid: true,
      },
      cli_email: {
        ...this.state.cli_email,
        value: loyaltyUser.email,
        valid: true,
      },
      cli_email2: {
        ...this.state.cli_email2,
        value: loyaltyUser.email,
        valid: true,
      },
      cli_city: {
        ...this.state.cli_city,
        value: loyaltyUser.city,
        valid: true,
      },
      cli_postal_code: {
        ...this.state.cli_postal_code,
        value: loyaltyUser.zip_code,
        valid: true,
      },
      cli_address: {
        ...this.state.cli_address,
        value: loyaltyUser.address,
        valid: true,
      },
    }, () => {
      const name_validation = this.validateFormField(FIELDS.CLI_NAME, loyaltyUser.first_name);
      const surname_validation = this.validateFormField(FIELDS.CLI_SURNAME, loyaltyUser.surname);
      const phone_validation = this.validateFormField(
        FIELDS.CLI_PHONE,
        loyaltyUser.country ? `+${loyaltyUser.country.dial_code}${loyaltyUser.phone_number}`
          : loyaltyUser.phone_number,
      );
      const email_validation = this.validateFormField(FIELDS.CLI_EMAIL, loyaltyUser.email);
      const email_validation2 = this.validateFormField(FIELDS.CLI_EMAIL2, loyaltyUser.email);
      this.setState({
        cli_name: { ...this.state.cli_name, ...name_validation },
        cli_surname: { ...this.state.cli_surname, ...surname_validation },
        cli_phone: { ...this.state.cli_phone, ...phone_validation },
        cli_email: { ...this.state.cli_email, ...email_validation },
        cli_email2: { ...this.state.cli_email2, ...email_validation2 },
      });
    });
  }

  async onChangeValue(fieldName, event, isBlur) {
    const value = event.target.type === 'checkbox'
      ? event.target.checked
      : event.target.value;
    const updatedState = {
      value,
    };

    // Solo actualizamos el estado inmediatamente con el nuevo valor
    this.setState({
      [fieldName]: { ...this.state[fieldName], ...updatedState },
    });

    if (isBlur) {
      sendSimpleGAEvent('abandformcomp', fieldName);

      const fieldValidate = await this.validateFormField(fieldName, value);
      this.setState({
        [fieldName]: {
          ...this.state[fieldName],
          valid: fieldValidate.valid,
          msg: fieldValidate.msg,
        },
      });

      const defaultState = {
        required: false,
        value: '',
        valid: undefined,
        msg: '',
      };

      if (fieldName === 'is_travel_agent' && value) {
        this.setState({
          agent_code: { ...this.state.agent_code, required: true },
        });
      } else if (fieldName === 'is_travel_agent') {
        // We must to reset agent_code value if the selected option is not agent.
        this.setState({
          agent_code: { ...this.state.agent_code, ...defaultState },
        });
      }

      if (fieldName === 'fill_with_user_data' && value) {
        this.fill_with_user_data_activate();
      } else if (fieldName === 'fill_with_user_data') {
        this.setState({
          cli_name: { ...this.state.cli_name, value: '' },
          cli_surname_2: { ...this.state.cli_surname_2, value: '' },
          cli_surname: { ...this.state.cli_surname, value: '' },
          cli_phone: { ...this.state.cli_phone, value: '' },
          cli_email: { ...this.state.cli_email, value: '' },
          cli_email2: { ...this.state.cli_email2, value: '' },
        });
      }
    } else if (fieldName !== FIELDS.CLI_EMAIL && fieldName !== FIELDS.CLI_EMAIL2
      && fieldName !== FIELDS.CARD_NUMBER) {
      // Validación en tiempo real para campos que no son email
      const fieldValidate = await this.validateFormField(fieldName, value);
      this.setState({
        [fieldName]: {
          ...this.state[fieldName],
          valid: fieldValidate.valid,
          msg: fieldValidate.msg,
        },
      });
    }
  }

  onFocusInput(fieldName) {
    sendSimpleGAEvent('abandformincomp', fieldName);
  }

  onPhoneBlur(phoneNumber) {
    const fieldName = FIELDS.CLI_PHONE;
    const event = {
      target: {
        type: 'text',
        value: phoneNumber,
      },
    };
    this.onChangeValue(fieldName, event, true);
  }

  onSaveBudget(obj) {
    this.toggleBudgetModal();
    const {
      loyalty, isCallCenterUser, cart, cartHotel, lang,
    } = this.props;
    const { amount } = cart;
    const isLoyaltyUser = isCallCenterUser ? loyalty.selectedStatus !== LOYALTY_STATUS.DONT_WANT_MEMBER
      : loyalty.loggedUser !== null;
    return this.props.sendBudgetEmail({
      name: obj.name,
      email: obj.email,
      totalPrice: `${cartHotel.currency.symbol}${amount[cartHotel.currency.code]} ${cartHotel.currency.code}`,
      lang,
      isLoyalty: loyalty.selectedStatus === LOYALTY_STATUS.BECOME_MEMBER || isLoyaltyUser,
    }).then((response) => {
      this.setState({ budgetSent: !(!response || !response.token) });
      this.toggleBudgetSentModal();
    });
  }

  async checkMember(email) {
    const stateForAgentCode = store.getState();
    const agentCodeEnteredInBookingForm = stateForAgentCode.booking.agentCode;
    const agentSellEnteredInBookingForm = stateForAgentCode.booking.agentSell;

    const results = await this.props.getMemberInfo({ email });
    if (agentCodeEnteredInBookingForm !== '' && agentSellEnteredInBookingForm === 'true') {
      //Cuando es un agente y ese agente vende a otros clientes (agentSell=true)
      //consumimos a getMemberInfo para indicar visualmente si el cliente
      //ya es miembro de loyalty o todavía no. Seteamos las banderas para indicar visualmente
      //si el cliente es un miembro de loyalty o no
      if (results) {
        const { info } = results;
        if (info && info.discount_available_percentage && agentSellEnteredInBookingForm === 'true') {
          this.setState({ agent_sell_true_client_is_loyalty_member: true });
          this.setState({ showClientIsLoyaltyMember: true });
        } else {
          this.setState({ agent_sell_true_client_is_loyalty_member: false });
          this.setState({ showClientIsLoyaltyMember: true });
        }
        //CONTROL DE LOGIN EN LOYALTY
        //Si es un usuario de loyalty, ya está logueado, está oculto el loyaltyRedeemDiv
        //y vamos a setearle coinsApplied a 0 para que no use coins
        //Se pidió que cuando agentSell=true, que no se le permitiera logearse al usuario a
        //loyalty, y por lo tanto que no pudiera pagar con coins. Lo que estamos haciendo
        //es logear al cliente, pero no mostrar que está logeado, y ponerle 0 coins a usar
        //así se puede asociar esa booking a ese usuario de loyalty de una manera transparente
        //Por alguna razón no se puede poner acá ese setCoinsApplied y setCoinsEntered, no lo hace
        //debemos ponerlo en otra parte o con un setTimeout para que funcione porque es asíncrono la parte
        //de arriba y posiblemente se haga primero lo de abajo y lo de arriba después
        //Si hay un agentCode y agentSell es true, significa que el usuario es un agente de smaragents y que
        //ese usuario vende reservas para otros clientes
        //se pidió que no se dejara al cliente final pagara con coins, de hecho se pidió que no se dejara logear
        //a loyalty. En este caso nosotros no mostramos la opción para que el cliente final se logee a loyalty
        //pero por debajo sí lo logueamos para que se pueda asociar esa booking a su usuario de loyalty de ese
        //usuario final. Por eso le debemos poner que use 0 coins, sólo para que se asocie la booking a ese cliente final
        setTimeout(() => {
          this.props.setCoinsApplied(0);
          this.props.setCoinsEntered(0);
        }, '2000');
      } else if (agentSellEnteredInBookingForm === 'true') {
        //Indicamos visualmente que el usuario del que puso el correo no es un miembro de loyalty
        this.setState({ agent_sell_true_client_is_loyalty_member: false });
        this.setState({ showClientIsLoyaltyMember: true });
      }
    }
    //const results = await this.props.getMemberInfo({ email });
    /*if (results) {
      const { info, user } = results;
      this.setState({
        cli_country: Object.assign({}, this.state.cli_country, {
          value: user.country,
        }),
        cli_phone: Object.assign({}, this.state.cli_phone, {
          value: `+${this.props.default_confirm_country.dial_code}`,
        }),
      });
    }*/

    if (agentCodeEnteredInBookingForm !== '' && agentSellEnteredInBookingForm === 'false') {
      // Si hay un agente y ese agente no va a vender a otros clientes es cuando lo logeamos en loyalty
      // y además cargamos su información en ese formulario que no será editable
      this.setState({
        fill_with_user_data: { ...this.state.fill_with_user_data, value: true },
      });
      this.fill_with_user_data_activate();
    }
  }

  renderLoading() {
    return (
      <div className="row">
        <div className="col-md-12 col-sm-12" style={{
          justifyItems: 'center',
          marginTop: '20px',
        }}>
          <img src="/img/loading5.gif"/>
          <p style={{ fontWeight: 'bold', fontSize: '16px' }}>
            {this.state.showLoadingRetrieving && this.context.t('Loading booking information...')}
            {this.state.showLoadingSaving && this.context.t('Saving booking information...')}
          </p>
        </div>
      </div>
    );
  }

  render() {
    if (!this.props.hotel) {
      return null;
    }
    const { bookNow } = this.state;
    return (
            <>
              {(this.state.showLoadingRetrieving || this.state.showLoadingSaving) && this.renderLoading()}
              { (this.state.showLoadingRetrieving === false && this.state.showLoadingSaving === false)
                && <div className={`ConfirmForm my-4 ${this.props.isDisabled && 'extra-disabled'}`}>
                  {this.state.isVisibleTerms && this.renderTerms()}
                  {this.state.isVisibleBudgetTerms && this.renderBudgetTerms()}
                  {this.state.isVisibleBudgetModal && this.renderBudgetModal()}
                  {this.state.isVisibleBudgetSentModal && this.renderBudgetSentModal()}
                  {bookNow ? this.renderWaitScreen() : this.renderForm()}
                </div>
              }
            </>
    );
  }

  /** BLOCK: Renders ****************************************************************************** */

  renderAgentCodeTemplate() {
    if (!this.state.is_travel_agent.value) {
      return null;
    }
    const state = store.getState();
    if (state.booking.agentCode !== '') {
      // Si hay agentCode no mostrar esta parte
      return null;
    }
    const { agent_code } = this.state;
    const msg = state.booking.agentCode != null ? '' : this.description(FIELDS.AGENT_CODE);
    const agentCode = { ...agent_code, msg };
    return (
            <FormControl
                    inputData={agentCode}
                    label={this.label(FIELDS.AGENT_CODE)}
                    onChange={this.onChangeValue}
            >
              <input type="text" disabled={state.booking.agentCode !== ''}/>
            </FormControl>
    );
  }

  renderAutoFillCheckBox() {
    const { state } = this;
    const { FILL_WITH_USER_DATA } = FIELDS;
    const stateForAgentCode = store.getState();
    const agentCodeEnteredInBookingForm = stateForAgentCode.booking.agentCode;
    const agentSellEnteredInBookingForm = stateForAgentCode.booking.agentSell;
    //Cuando hay un agente y no va a vender lo deshabilitamos
    return (
            <React.Fragment>
              <Checkbox
                      id="inp_fill_with_user_data"
                      label={this.label(FILL_WITH_USER_DATA)}
                      checked={state.fill_with_user_data.value}
                      errorMsg={state.fill_with_user_data.msg}
                      onChange={(ev) => this.onChangeValue(FILL_WITH_USER_DATA, ev, true)}
                      disabled={agentCodeEnteredInBookingForm !== '' && agentSellEnteredInBookingForm === 'false'}
              />
            </React.Fragment>
    );
  }

  renderBackButton() {
    return (
            <BtnBase
                    iconAfter={'fa fa-long-arrow-full md:w-lef'}
                    className={'button-back w-fit'}
                    onClick={this.goBackRooms}
                    label={this.context.t('Back')}/>
    );
  }

  renderBookNowButton() {
    const isBudgetsEnabled = this.props.session.chainData.budgets_enabled;
    // Antes estaba como className="bookNow__area mt-auto md:ml-auto"
    return (
            <div className="bookNow__area mt-auto md:ml-auto">
              {isBudgetsEnabled && this.props.locator == null && this.renderBudgetBox()}
              {/*this.renderRoomKeyPoints()*/}
              {/*this.renderRoomExtras()*/}
              <div
                      role="button"
                      className="btn btn-primary button-next"
                      style={{ display: 'none' }}
                      //onClick={this.onBookNowClick}
              >
                {this.context.t('Book now')}
              </div>
            </div>
    );
  }

  renderBudgetBox() {
    return (
            <BudgetBox onShowSave={this.toggleBudgetModal} onShowInfo={this.toggleBudgetTermMessages}/>
    );
  }

  renderBudgetModal() {
    return (
            <ModalDialog
                    titleElement={<span
                            className="ml-1 share-header__title uppercase">{this.context.t('Save your price for 24hrs')}</span>}
                    bodyElement={
                      <BudgetForm onSaveBudget={this.onSaveBudget} paymentMethod={this.state.paymentMethod}/>
                    }
                    actions={[]}
                    clickHandler={this.toggleBudgetModal}
                    isVisible
            />
    );
  }

  renderBudgetSentModal() {
    return (
            <ModalDialog
                    titleElement={<span
                            className="ml-1 share-header__title uppercase">{this.state.budgetSent ? this.context.t('Budget Sent') : this.context.t('Budget Error')}</span>}
                    bodyElement={
                      <div
                              className="text-lg rounded-md bg-white p-6 leading-loose"
                      >
                        {this.state.budgetSent ? (
                                <p>{this.context.t('Budget sent correctly. You will receive an email with a link to access it')}</p>) : (
                                <p>{this.context.t('Sorry, your budget could not be saved. Please try again or contact our Call Center for assistance')}</p>
                        )}
                      </div>
                    }
                    clickHandler={this.toggleBudgetSentModal}
                    isVisible
            />);
  }

  renderBudgetTerms() {
    return (
            <ModalDialog
                    contentClass="vertical-scroll"
                    isVisible
                    titleElement={<span
                            className="ml-1 share-header__title">{this.context.t('Terms & Conditions')}</span>}
                    bodyElement={
                      <div>
                        <ul className={'list-base'}>
                          <li className={'py-1'}>{this.context.t('You have 24 hours to confirm your reservation without changes in both availability and the initial price.')}</li>
                          <li className={'py-1'}>{this.context.t('During that time, we will send you an e-mail with all the data you have saved and a link so you can continue with your reservation.')}</li>
                          <li className={'py-1'}>{this.context.t('If after 24 hours you have not formalized your reservation, both the price and its availability could change.')}</li>
                        </ul>
                      </div>}
                    actions={[]}
                    clickHandler={this.toggleBudgetTermMessages}
            />
    );
  }

  renderCardTypes() {
    const cardTypeClass = (code) =>
      `${this.state.card_type.value.code === code ? 'text-orange-600' : ''}`;
    return (
            <div className="mb-4">
              <p className="uppercase text-primary-500 text-base font-bold">
                {this.context.t('Please, select your payment method')}
              </p>
              <ul className="flex -mx-2 my-3 flex-wrap">
                {this.paymentCards.map((cardType) => (
                        <li
                                key={cardType.code}
                                onClick={() => this.setCardType(cardType)}
                                className={`${cardTypeClass(
                                  cardType.code,
                                )} flex flex-col items-center mx-2 cursor-pointer`}
                        >
                          <i
                                  className={`fa fa-${
                                    cardType.icon_class || 'credit-card'
                                  } text-6xl`}
                          />
                          <p className="my-1">{cardType.name}</p>
                          <RadioSelectIcon
                                  isSelected={this.state.card_type.value.code === cardType.code}
                          />
                        </li>
                ))}
              </ul>
            </div>
    );
  }

  renderForm() {
    const stateForAgentCode = store.getState();
    const agentCodeEnteredInBookingForm = stateForAgentCode.booking.agentCode;

    return (
            // eslint-disable-next-line react/no-string-refs
            <form ref="confirmForm" noValidate onSubmit={this.formPreventDefault}>
              <div className="form-title  mt-4">
                <h2>{this.context.t('Enter your details, you\'re almost done!')}</h2>
                {this.props.loyaltyUser && agentCodeEnteredInBookingForm === '' && this.renderAutoFillCheckBox()}
              </div>
              {this.renderPersonalInfoFields()}
              <div className="d-flex flex-wrap lg:flex-nowrap mt-8">
                <div className="flex-grow-default flex flex-col" style={{ minWidth: '300px' }}>
                  {this.props.locator == null && this.renderPaymentOptions()}
                  {this.props.locator == null && this.renderTermNewsCheckboxes()}
                  {this.showErrorMessage()}
                  { this.props.isDesktop === true && this.props.locator == null && this.renderBackButton()}
                </div>
                <div className="inline-flex flex-col md:pl-8 items-center">
                  {this.renderBookNowButton()} {/* De todos modos ese botón tiene un display:none*/}
                  {this.props.locator == null && this.renderOnlinePaymentTip()}
                </div>
              </div>
            </form>
    );
  }

  renderOnlinePaymentTip() {
    const selectedMethod = this.getSelectedMethod(
      this.props.paymentMethods,
    ) || { is_tpv: false };
    if (!selectedMethod.is_tpv || selectedMethod.code === 'ADYEN') {
      return null;
    }
    return (
            <div className="online-payment-tip">
              {this.context.t(
                'Online payment will take place on the next page through a secure portal.',
              )}
            </div>
    );
  }

  renderPaymentFields(selectedMethod) {
    const { state } = this;
    const { lang, paymentMethods } = this.props;
    const {
      CARD_TYPE,
      CARD_NUMBER,
      CARD_HOLDER,
      CARD_CVC,
      CARD_EXPIRATION_MONTH,
      CARD_EXPIRATION_YEAR,
    } = FIELDS;

    // In this form (payment at hotel) we must to ignore the payment cards only necessary for tpv
    const paymentCards = this.paymentCards.filter(
      (cardType) => !cardType.only_for_tpv,
    );
    return (
            <div className="flex flex-wrap -mx-2">
              <div className="px-2  w-full">
                <FormControl inputData={{ name: 'paymentMethod' }} label="">
                  <Select
                          selectId="paymentMethod"
                          options={paymentMethods}
                          selectedValue={selectedMethod}
                          keyCode="code"
                          lang={lang}
                          onSelect={(item) => this.onChangeSelect('paymentMethod', item)}
                  />
                </FormControl>
              </div>
              <div className="px-2 w-full md:w-1/2">
                <FormControl
                        inputData={state.card_type}
                        label={this.label(CARD_TYPE)}
                        onChange={this.onChangeValue}
                >
                  <DsDropdownList
                          selectId="cardType-input"
                          className="h-8"
                          initialId={[]}
                          items={paymentCards}
                          selectedItem={state.card_type.value}
                          lang={lang}
                          onChange={this.onChangeSelect}
                  />
                </FormControl>
              </div>
              <div className="px-2 w-full md:w-1/2">

                <FormControl
                        inputData={state.card_number}
                        label={this.label(CARD_NUMBER)}
                        onChange={this.onChangeValue}
                        onFocus={this.onFocusInput}
                >
                  <input
                          type="text"
                          required
                          minLength={14}
                          maxLength={19}
                          autoComplete="cc-number"
                  />
                </FormControl>
              </div>
              <div className="px-2 w-full md:w-1/2">
                <FormControl
                        inputData={state.card_holder}
                        label={this.label(CARD_HOLDER)}
                        onChange={this.onChangeValue}
                        onFocus={this.onFocusInput}
                >
                  <input type="text" required autoComplete="cc-name"/>
                </FormControl>
              </div>
              <div className="px-2 w-full md:w-1/6">
                <FormControl
                        inputData={state.card_expiration_month}
                        label={this.label(CARD_EXPIRATION_MONTH)}
                        onChange={this.onChangeValue}
                >
                  <DsDropdownList
                          selectId="expiryMonth-input"
                          className="h-8"
                          initialId={[]}
                          items={this.months}
                          selectedItem={state.card_expiration_month.value}
                          lang={lang}
                          onChange={this.onChangeSelect}
                  />
                </FormControl>
              </div>
              <div className="px-2 w-full md:w-1/6">
                <FormControl
                        inputData={state.card_expiration_year}
                        label={this.label(CARD_EXPIRATION_YEAR)}
                        onChange={this.onChangeValue}
                >
                  <DsDropdownList
                          selectId="expiryYear-input"
                          className="h-8"
                          items={this.state.card_type.value.code === 'AMEX' ? this.yearsAmex : this.years}
                          initialId={[]}
                          selectedItem={state.card_expiration_year.value}
                          lang={lang}
                          onChange={this.onChangeSelect}
                  />
                </FormControl>
              </div>
              <div className="px-2 w-full md:w-1/6">
                <FormControl
                        inputData={state.card_cvc}
                        label={this.label(CARD_CVC)}
                        onChange={this.onChangeValue}
                        onFocus={this.onFocusInput}
                >
                  <input
                          type="text"
                          required
                          autoComplete="cc-csc"
                          minLength={this.state.card_type.value.code === 'AMEX' ? 4 : 3}
                          maxLength={this.state.card_type.value.code === 'AMEX' ? 4 : 3}
                          pattern="\d*"
                  />
                </FormControl>
              </div>
            </div>
    );
  }

  renderPaymentMethodError(msg) {
    return <div className="error-messages">{msg}</div>;
  }

  renderPaymentOptions() {
    if (!this.hasPaymentMethods()) {
      const msg = this.context.t(
        'This rate has no payment method available, please choose another rate.',
      );
      return this.renderPaymentMethodError(msg);
    }

    const selectedMethod = this.getSelectedMethod(this.props.paymentMethods);
    if (!selectedMethod) {
      const msg = this.context.t(
        'Updating available payment methods, please wait...',
      );
      return this.renderPaymentMethodError(msg);
    }
    return (
            <React.Fragment>
              <div className="form-title mt-4">
                {this.context.t('When would you like to pay?')}
              </div>
              {selectedMethod.request_card
                ? this.renderPaymentFields(selectedMethod)
                : this.renderTPVFields(selectedMethod)}
              {selectedMethod.request_card_type && this.renderCardTypes()}
            </React.Fragment>
    );
  }

  onClose = () => {
    this.setState({ showClientIsLoyaltyMember: false });
  };

  render_agent_sell_true_client_is_loyalty_member() {
    return null;

    //Anteriormente se había solicitado que cuando es un agente, es decir, cuando
    //hay un agentCode y cuando la reserva es para un cliente final, es decir,
    //cuando agentSell es "true", primero habían pedido que al poner el correo
    //del cliente en el formulario de confirmación, que se visualizara con un mensaje
    //si el cliente es un miembro de loyalty o si no lo es
    //Posteriormente solicitaron que no se mostrara ese mensaje, por lo que comento
    //la parte con la que se hacía eso se comentó y ahora sólo se regresa null
    //lo dejo comentado por si en otra ocasión deciden volver a mostrar ese mensaje

    /*const stateForAgentCode = store.getState();
    const agentCodeEnteredInBookingForm = stateForAgentCode.booking.agentCode;
    const agentSellEnteredInBookingForm = stateForAgentCode.booking.agentSell;
    if (agentCodeEnteredInBookingForm !== '' && agentSellEnteredInBookingForm === 'true') {
      //Sólo si es un agente y ese agente va a vender reservas a otros clientes
      //es cuando consumimos el endpoint de memderInfo para saber si ese correo
      //corresponde a un miembro de loyalty o no y mostrar el resultado usando este método
      const { agent_sell_true_client_is_loyalty_member, showClientIsLoyaltyMember } = this.state;
      if (agent_sell_true_client_is_loyalty_member === true && showClientIsLoyaltyMember) {
        return (
          // eslint-disable-next-line react/no-string-refs
          <div className="ClientAlreadyLoyaltyMember animated bounceInLeft" ref="ClientAlreadyLoyaltyMember"
          onClick={this.onClose}>
            {this.props.loyaltyName} {this.context.t('member')}: <b>{this.context.t('YES!')}</b>
          </div>
        );
      }
      if (agent_sell_true_client_is_loyalty_member === false && showClientIsLoyaltyMember) {
        return (
          // eslint-disable-next-line react/no-string-refs
          <div className="ClientAlreadyLoyaltyMember animated bounceInLeft" ref="ClientAlreadyLoyaltyMember"
          onClick={this.onClose}>
             {this.props.loyaltyName} {this.context.t('member')}: <b>{this.context.t('NO!')}</b>
          </div>
        );
      }
    }
    return null;*/
  }

  fillFieldsIsEditingBooking(locator, email, lang) {
    //this.setState({ pageStatus: 'loading', bookingBeingEdited: null });
    this.setState({ showLoadingRetrieving: true });
    this.props.getBookingDetail(lang, locator, 'email', email).then((response) => {
      const { booking } = response;
      if (booking) {
        // Obtener el valor de book_arrival_time o usar un valor por defecto
        const arrivalTime = booking.book_arrival_time || '08:00';
        // Verificar si el valor existe en las opciones disponibles
        const arrivalTimeOption = this.state.book_arrival_times.options.find(
          (option) => option.code === arrivalTime,
        ) || { code: arrivalTime, name: arrivalTime };

        this.setState({
          cli_name: {
            ...this.state.cli_name,
            value: booking.cli_name,
            valid: true,
          },
          cli_middle_name: {
            ...this.state.cli_middle_name,
            value: booking.cli_middle_name,
            valid: true,
          },
          [FIELDS.CLI_SURNAME2]: {
            ...this.state.cli_surname2,
            value: booking.cli_surname2,
            valid: true,
          },
          cli_surname: {
            ...this.state.cli_surname,
            value: booking.cli_surname,
            valid: true,
          },
          cli_email: {
            ...this.state.cli_email,
            value: booking.cli_email,
            valid: true,
          },
          cli_email2: {
            ...this.state.cli_email2,
            value: booking.cli_email,
            valid: true,
          },
          cli_city: {
            ...this.state.cli_city,
            value: booking.cli_city,
            valid: true,
          },
          cli_address: {
            ...this.state.cli_address,
            value: booking.cli_address,
            valid: true,
          },
          [FIELDS.CLI_PHONE]: {
            ...this.state.cli_phone,
            value: booking.cli_phone,
            valid: true,
          },
          cli_country: {
            ...this.state.cli_country,
            value: {
              name: booking.cli_country_object ? getLangValue(booking.cli_country_object, lang, 'name') : '',
              iso_code: booking.cli_country_object ? booking.cli_country_object.iso_code : '',
              valid: true,
            },
          },
          cli_postal_code: {
            ...this.state.cli_postal_code,
            value: booking.cli_postal_code,
            valid: true,
          },
          book_arrival_time: {
            ...this.state.book_arrival_time,
            value: arrivalTimeOption, // Usar el objeto de opción encontrado o creado
            valid: true,
          },
          book_comments: {
            ...this.state.book_comments,
            value: booking.comments,
            valid: true,
          },
        });
      } else {
        //this.setState({ pageStatus: 'error' });
      }
      this.setState({ showLoadingRetrieving: false });
    });
  }

  renderPersonalInfoFields() {
    const { state } = this;
    const { lang } = this.props;
    const {
      CLI_NAME,
      CLI_MIDDLE_NAME,
      CLI_SURNAME,
      CLI_SURNAME2,
      CLI_COUNTRY,
      CLI_EMAIL,
      CLI_EMAIL2,
      CLI_POSTAL_CODE,
      BOOK_COMMENTS,
      CLI_ADDRESS,
      CLI_CITY,
      BOOK_ARRIVAL_TIME,
      IS_TRAVEL_AGENT,
    } = FIELDS;
    const state2 = store.getState();

    let agentCountry = '';

    if ((state2.booking.agentCode !== '') || (this.props.loyaltyEnabled && !this.props.loyaltyUser)) {
      // Acá seteamos el checkbox de que es un agent code porque ya traemos un agentcode desde el bookingform
      // No especificamos si va a vender a otros clientes o hará reservas para el mismo, sólo es para poner
      // el checkbox checked de que es un agente y mostraremos su agentCode
      if (state2.booking.agentCode !== '') {
        state.is_travel_agent.value = true;
        state.agent_code.value = state2.booking.agentCode;

        if (state2.loyalty.loggedUser != null) {
          if (state2.loyalty.loggedUser.country != null) {
            agentCountry = state2.loyalty.loggedUser.country[`name_${lang}`] != null
              ? state2.loyalty.loggedUser.country[`name_${lang}`] : state2.loyalty.loggedUser.country.name;
          }
        }
      }
    }
    let agent_email = null;
    if (this.props.agentCode !== '' && this.props.agentSell === 'true') {
      agent_email = this.props.loyaltyUser ? this.props.loyaltyUser.email : null;
    }
    return (
            <>
              <div className="form-fields123">
                <div className="flex flex-wrap -mx-2">
                  <div className="px-2 w-full md:w-1/2">
                    <FormControl
                            inputData={state.cli_name}
                            label={this.label(CLI_NAME)}
                            onChange={this.onChangeValue}
                            onFocus={this.onFocusInput}
                    >
                      <input
                              type="text"
                              required
                              minLength={2}
                              maxLength={80}
                              autoComplete="name"
                              value={state.cli_name.value}
                              disabled={state2.booking.agentCode !== '' && state2.booking.agentSell === 'false'}
                      />
                    </FormControl>
                  </div>
                  <div className="px-2 w-full md:w-1/2">
                    <FormControl
                            inputData={state.cli_middle_name}
                            label={this.label(CLI_MIDDLE_NAME)}
                            onChange={this.onChangeValue}
                            onFocus={this.onFocusInput}
                    >
                      <input
                              type="text"
                              minLength={2}
                              maxLength={80}
                              autoComplete="name"
                              value={state.cli_middle_name.value}
                              disabled={state2.booking.agentCode !== '' && state2.booking.agentSell === 'false'}
                      />
                    </FormControl>
                  </div>
                  <div className="px-2 w-full md:w-1/2">
                    <FormControl
                            inputData={state.cli_surname}
                            label={this.label(CLI_SURNAME)}
                            onChange={this.onChangeValue}
                            onFocus={this.onFocusInput}
                    >
                      <input
                              type="text"
                              required
                              minLength={2}
                              maxLength={80}
                              autoComplete="name"
                              value={state.cli_surname.value}
                              disabled={state2.booking.agentCode !== '' && state2.booking.agentSell === 'false'}
                      />
                    </FormControl>
                  </div>
                  <div className="px-2 w-full md:w-1/2">
                    <FormControl
                            inputData={state.cli_surname2}
                            label={this.label(CLI_SURNAME2)}
                            onChange={this.onChangeValue}
                            onFocus={this.onFocusInput}
                    >
                      <input
                              type="text"
                              minLength={2}
                              maxLength={80}
                              autoComplete="name"
                              value={state.cli_surname2.value}
                              disabled={state2.booking.agentCode !== '' && state2.booking.agentSell === 'false'}
                      />
                    </FormControl>
                  </div>
                  <div className="px-2 w-full">
                    <FormControl
                            inputData={state.cli_address}
                            label={this.label(CLI_ADDRESS)}
                            onChange={this.onChangeValue}
                            onFocus={this.onFocusInput}
                    >
                      <input type="text" required maxLength={80} disabled={state2.booking.agentCode !== ''
                      && state2.booking.agentSell === 'false'}/>
                    </FormControl>
                  </div>
                  <div className="px-2 w-full md:w-1/2">
                    <FormControl
                            inputData={state.cli_city}
                            label={this.label(CLI_CITY)}
                            onChange={this.onChangeValue}
                            onFocus={this.onFocusInput}
                    >
                      <input type="text" required maxLength={20} disabled={state2.booking.agentCode !== ''
                      && state2.booking.agentSell === 'false'}/>
                    </FormControl>
                  </div>
                  <div className="px-2 w-full md:w-1/2">
                    {((state2.booking.agentCode === '' && state.countries.options.length > 0)
                      || (state2.booking.agentCode !== '' && state2.booking.agentSell === 'true')) && (
                            <FormControl
                                    inputData={state.cli_country}
                                    label={this.label(CLI_COUNTRY)}
                                    onChange={this.onChangeValue}
                                    onFocus={this.onFocusInput}
                            >
                              <DsDropdownList
                                      className="h-8"
                                      initialId={[]}
                                      items={state.countries.options}
                                      searchText={state.cli_country.value.name}
                                      onChange={(name, ev) => this.onChangeSelect(name, ev)}
                                      withSearch
                              />
                            </FormControl>
                    )}

                    {state2.booking.agentCode !== '' && state2.booking.agentSell === 'false'
                    && state2.loyalty.loggedUser != null && (
                          <div>
                            <div style={{ display: 'none' }}>
                            <FormControl
                                      inputData={state.cli_country}
                                      label={this.label(CLI_COUNTRY)}
                                      onChange={this.onChangeValue}
                                      onFocus={this.onFocusInput}
                              >
                                <DsDropdownList
                                        className="h-8"
                                        initialId={[]}
                                        items={state.countries.options}
                                        searchText={state.cli_country.value.name}
                                        onChange={(name, ev) => this.onChangeSelect(name, ev)}
                                        withSearch
                                />
                              </FormControl>
                              </div>
                              <FormControl
                                inputData={state.cli_country.value.name}
                                label={this.label(CLI_COUNTRY)}
                                onChange={this.onChangeValue}
                                onFocus={this.onFocusInput}
                              >
                                <input type="text" maxLength={80} defaultValue={agentCountry}
                                disabled={state2.booking.agentCode !== '' && state2.booking.agentSell === 'false'} />
                              </FormControl>
                            </div>

                    )}

                  </div>
                  <div className="px-2 w-full md:w-1/2">
                    <FormControl
                            inputData={state.cli_postal_code}
                            label={this.label(CLI_POSTAL_CODE)}
                            onChange={this.onChangeValue}
                            onFocus={this.onFocusInput}
                    >
                      <input type="text" required maxLength={20} disabled={state2.booking.agentCode !== ''
                      && state2.booking.agentSell === 'false'}/>
                    </FormControl>
                  </div>
                  <div className="px-2 w-full md:w-1/2">{this.renderPhoneSelector(state2.booking.agentCode !== ''
                  && state2.booking.agentSell === 'false')}</div>
                  <div className="px-2 w-full md:w-1/2">
                    {this.render_agent_sell_true_client_is_loyalty_member()}
                    <FormControl
                            inputData={state.cli_email}
                            label={this.label(CLI_EMAIL)}
                            onChange={this.onChangeValue}
                            onFocus={this.onFocusInput}
                    >
                      <input type="email" required autoComplete="email" disabled={state2.booking.agentCode !== ''
                      && state2.booking.agentSell === 'false'}/>
                    </FormControl>
                  </div>
                  <div className="px-2 w-full md:w-1/2">
                    <FormControl
                            inputData={state.cli_email2}
                            label={this.label(CLI_EMAIL2)}
                            onChange={this.onChangeValue}
                            onFocus={this.onFocusInput}
                    >
                      <input type="email" required autoComplete="email" disabled={state2.booking.agentCode !== ''
                      && state2.booking.agentSell === 'false'}/>
                    </FormControl>
                  </div>
                  {
                  this.props.agentCode !== '' && this.props.agentSell === 'true'
                  && <div className="px-2 w-full md:w-1/2">
                        <span
                          style={{
                            display: 'block',
                            color: '#a7a8aa',
                            margin: '15px 0 10px',
                            fontSize: '0.825rem',
                          }}
                        >
                          {this.context.t('Agent e-mail:')}
                        </span>
                        <span
                          style={{
                            display: 'block',
                            color: '#a7a8aa',
                            margin: '15px 0 10px',
                            fontSize: '0.825rem',
                          }}
                        >
                          {agent_email}
                        </span>
                      </div>
                  }
                  <div className="px-2 w-full">
                    <FormControl
                            inputData={state.book_comments}
                            label={this.label(BOOK_COMMENTS)}
                            onChange={this.onChangeValue}
                    >
                      <textarea wrap="on" maxLength={500}/>
                    </FormControl>
                  </div>
                  <div className="px-2 w-full hora-de-llegada">
                    <FormControl
                            inputData={state.book_arrival_time}
                            label={this.label(BOOK_ARRIVAL_TIME)}
                            onChange={this.onChangeValue}
                            onFocus={this.onFocusInput}

                    >
                      <DsDropdownList
                              className="h-8"
                              initialId={[]}
                              items={state.book_arrival_times.options}
                              searchText={state.book_arrival_time.value.name}
                              onChange={(name, ev) => this.onChangeSelect(name, ev)}
                              withSearch
                      />
                    </FormControl>
                  </div>
                </div>
                {((state2.booking.agentCode === '') && (this.props.loyaltyEnabled && !this.props.loyaltyUser))
                // Si hay agentCode no mostrar esta parte, sólo mostrar cuando no haya agente, es decir
                // en el flujo normal
                && (
                        <Checkbox
                                id="inp_is_travel_agent"
                                label={this.label(IS_TRAVEL_AGENT)}
                                checked={state.is_travel_agent.value}
                                errorMsg={state.is_travel_agent.msg}
                                onChange={(ev) => this.onChangeValue(IS_TRAVEL_AGENT, ev, true)}
                        />
                )}
                {this.renderAgentCodeTemplate()}
              </div>
              {this.props.locator && this.props.isInBookingDetailsPage === true
                && <EditContactInfoButtons
                  onCancel={this.handleCancel}
                  onSave={this.handleSave}
                />
              }
            </>
    );
  }

  handleCancel = () => {
    // Lógica para cancelar
    this.props.setShowEditBookingContactInformation(false);
  };

  handleSave = () => {
    // Lógica para guardar
    if (this.props.isInBookingDetailsPage === true) {
      this.saveBookingContactInfo();
    }
  };

  renderPhoneSelector(disabled = false) {
    const { cli_phone, countries, cli_country } = this.state;
    if (countries.options.length === 0) {
      return null;
    }
    return (
            <IntlTelInput
                    onNumberBlur={this.onPhoneBlur}
                    validationError={cli_phone.msg}
                    currentCountry={cli_country.value.iso_code}
                    countriesData={countries.options}
                    label={this.label(FIELDS.CLI_PHONE)}
                    lang={countries.lang}
                    valid={cli_phone.valid}
                    number={cli_phone.value}
                    required={true}
                    disabled={disabled}
            />
    );
  }

  renderRoomKeyPoints() {
    const { lang, cartHotel } = this.props;
    const rooms = cartHotel.rooms.map((cartRoom) => cartRoom.room);
    return <RoomKeySellingPoints rooms={rooms} lang={lang}/>;
  }

  renderRoomExtras() {
    const { lang, cartHotel } = this.props;
    const roomsJson = cartHotel.rooms;
    return <RoomExtras rooms={roomsJson} lang={lang}/>;
  }

  renderSecondSurname(disabled = false) {
    return (
            <FormControl
                    inputData={this.state.cli_surname2}
                    label={this.label(FIELDS.CLI_SURNAME2)}
                    onChange={this.onChangeValue}
                    onFocus={this.onFocusInput}
            >
              <input type="text" minLength={2} maxLength={80} disabled={disabled}/>
            </FormControl>
    );
  }

  renderSurname(disabled = false) {
    return (
            <FormControl
                    inputData={this.state.cli_surname}
                    label={this.label(FIELDS.CLI_SURNAME)}
                    onChange={this.onChangeValue}
                    onFocus={this.onFocusInput}
            >
              <input type="text" required minLength={2} maxLength={80} disabled={disabled}/>
            </FormControl>
    );
  }

  renderTermNewsCheckboxes() {
    const { state } = this;
    const { NEWSLETTER, BOOK_CONDITIONS } = FIELDS;
    return (
            <React.Fragment>
              <Checkbox
                      id="inp_acceptTerms"
                      label={this.label(BOOK_CONDITIONS)}
                      checked={state.book_conditions.value}
                      errorMsg={state.book_conditions.msg}
                      onChange={(ev) => this.onChangeValue(BOOK_CONDITIONS, ev, true)}
              />
              <Checkbox
                      id="inp_newsletter"
                      label={this.label(NEWSLETTER)}
                      checked={state.newsletter.value}
                      errorMsg={state.newsletter.msg}
                      onChange={(ev) => this.onChangeValue('newsletter', ev, true)}
              />
            </React.Fragment>
    );
  }

  renderTerms() {
    return (
            /* eslint-disable react/no-danger */
            <ModalDialog
                    contentClass="vertical-scroll"
                    isVisible
                    titleElement={this.context.t('Terms & Conditions')}
                    bodyElement={
                      <div
                              dangerouslySetInnerHTML={{ __html: this.props.cartHotel.policies }}
                      />
                    }
                    actions={[]}
                    clickHandler={this.toggleTermMessages}
            />
            /* eslint-enable react/no-danger */
    );
  }

  renderTPVFields(selectedMethod) {
    return (
            <div className="form-fields">
              <FormControl inputData={{ name: 'paymentMethod' }} label="">
                <>
                  <Select
                    selectId="paymentMethod"
                    options={this.props.paymentMethods}
                    selectedValue={selectedMethod}
                    keyCode="code"
                    lang={this.props.lang}
                    onSelect={(item) => this.onChangeSelect('paymentMethod', item)}
                  />
                  <div style={{
                    marginTop: '0px',
                    fontSize: '10px',
                    fontFamily: 'Noto Sans',
                    fontWeight: '500',
                    fontStyle: 'Medium',
                    letterSpacing: '0%',
                    textTransform: 'uppercase',
                    color: '#397B21',
                  }}>

                    { selectedMethod.code === 'ADYEN'
                    && selectedMethod.adyen_offer_installments === true
                    && selectedMethod.ip_country_code === 'MX'
                    && selectedMethod.adyen_installments_options !== ''
                    && this.context.t('Up to {months} months interest-free (with eligible credit cards)',
                      { months: selectedMethod.adyen_installments_options.split(',').map((item) => item.trim()).pop() })
                    }
                  </div>
                </>
              </FormControl>
              {this.props.isCallCenterUser && (
                      <Checkbox
                              id="inp_send_email"
                              label={this.context.t(
                                'Send an email with the Payment link to the customer',
                              )}
                              checked={this.state.sendPaymentEmail}
                              onChange={() => this.switchSendPaymentEmail()}
                      />
              )}
              <div className="tpv-payment"/>
            </div>
    );
  }

  renderWaitScreen() {
    return <ConfirmWaitScreen mode={this.state.waitScreenMode}/>;
  }

  /** END BLOCK: Renders *************************************************************************** */

  setCardType(cardType) {
    const cardTypeNewState = { ...this.state.card_type };
    cardTypeNewState.value.code = cardType.code;
    cardTypeNewState.valid = true;
    this.setState({ card_type: cardTypeNewState });
  }

  showErrorMessage() {
    const invalidFieldNames = this.getInvalidFieldNames();
    if (invalidFieldNames.length === 0 || !this.state.showErrorTooltip) {
      return null;
    }
    const { BOOK_CONDITIONS } = FIELDS;
    const missingFields = invalidFieldNames.filter(
      (field) => field !== BOOK_CONDITIONS,
    );
    const termField = invalidFieldNames.filter(
      (field) => field === BOOK_CONDITIONS,
    );
    const errorMsg = [];
    if (missingFields.length > 0) {
      errorMsg.push(
        `<b>${this.context.t('Fill in these missing fields to continue:')}</b>`,
      );
      errorMsg.push(
        missingFields
          .map((f) => this.label(f))
          .join(', ')
          .toUpperCase(),
      );
    }
    if (termField.length > 0) {
      errorMsg.push(this.context.t('Please accept Terms and Conditions'));
    }

    return (
            <div className="error-messages">
              <CloseIcon/>
              {/* eslint-disable react/no-danger */}
              <span
                      className="text"
                      dangerouslySetInnerHTML={{ __html: errorMsg.join('<br />') }}
              />
              {/* eslint-enable react/no-danger */}
            </div>
    );
  }

  switchSendPaymentEmail() {
    this.setState({ sendPaymentEmail: !this.state.sendPaymentEmail });
  }

  /** BLOCK: Toggles ******************************************************************************* */
  toggleBudgetModal(ev) {
    if (ev && ev.preventDefault) {
      // Preventing default when opening the terms to avoid the input checkbox from being clicked
      ev.preventDefault();
    }
    this.setState({ isVisibleBudgetModal: !this.state.isVisibleBudgetModal });
  }

  toggleBudgetTermMessages(ev) {
    if (ev.preventDefault) {
      // Preventing default when opening the terms to avoid the input checkbox from being clicked
      ev.preventDefault();
    }
    this.setState({ isVisibleBudgetTerms: !this.state.isVisibleBudgetTerms });
  }

  toggleBudgetSentModal() {
    this.setState({ isVisibleBudgetSentModal: !this.state.isVisibleBudgetSentModal });
  }

  toggleTermMessages(ev) {
    if (ev.preventDefault) {
      // Preventing default when opening the terms to avoid the input checkbox from being clicked
      ev.preventDefault();
    }
    this.setState({ isVisibleTerms: !this.state.isVisibleTerms });
  }

  /** END BLOCK: Toggles **************************************************************************** */

  updateFormState() {
    const { state } = this;
    const { loyalty, isCallCenterUser, session } = this.props;
    const stateForAgentCode = store.getState();
    const agentCodeEnteredInBookingForm = stateForAgentCode.booking.agentCode;
    let agentCode = '';
    if (agentCodeEnteredInBookingForm !== '') {
      agentCode = agentCodeEnteredInBookingForm;
    } else {
      agentCode = state.agent_code.valid ? state.agent_code.value.trim() : '';
    }
    //ACÁ NOS QUEDAMOS AL REVISAR TODO

    const paymentMethod = state.paymentMethod.value;
    const cardDetails = paymentMethod.request_card
      ? {
        card_type: state.card_type.value.code,
        card_number: state.card_number.value,
        card_holder: state.card_holder.value,
        card_expiration: this.getExpirationCardDate(),
        card_cvc: state.card_cvc.value,
      }
      : {};

    if (paymentMethod.request_card_type) {
      cardDetails.card_type = state.card_type.value.code;
    }

    const isLoyaltyUser = isCallCenterUser ? loyalty.selectedStatus !== LOYALTY_STATUS.DONT_WANT_MEMBER
      : !!(loyalty.memberInfo && loyalty.memberInfo.email);
    const loyaltyDetails = isLoyaltyUser ? {
      loyalty_user_id: loyalty.memberInfo.email,
      loyalty_user_current_coins: loyalty.memberInfo ? loyalty.memberInfo.availableCoins : 0,
      loyalty_coins_to_apply: loyalty.coinsApplied,
    } : {
      loyalty_user_id: null,
      loyalty_user_current_coins: null,
      loyalty_coins_to_apply: null,
    };

    let cardCode = this.props.loyaltyUser ? this.props.loyaltyUser.card_code : '';
    if (cardCode === '' && this.props.loyaltyMemberInfo && this.props.loyaltyMemberInfo.cardCode) {
      cardCode = this.props.loyaltyMemberInfo.cardCode;
    }
    let book_user_currency = null;
    if (this.props.cart.budget_token) {
      book_user_currency = this.props.hotel.currency.code;
    } else if (session.user && isCallCenterUser
        && this.props.callCenterCustomerCode.code === 'DIRECTOS_CALLCENTER_MEXICO') {
      book_user_currency = 'MXN';
    } else {
      book_user_currency = this.props.hotel.default_currency;
    }
    // Currency selected by the customer via the Payment Currency selector (USD/MXN only),
    // used to charge the card in the currency that matches the cardholder's bank.
    const book_payment_currency = this.props.paymentCurrency || book_user_currency;
    let agent_email = null;
    if (this.props.agentCode !== '' && this.props.agentSell === 'true') {
      agent_email = this.props.loyaltyUser ? this.props.loyaltyUser.email : null;
    }
    Object.assign(this.confirmFormState, {
      // Con ésto se soluciona error de no mandar el token en la confirmación de la booking
      budget_token: this.props.cart.budget_token,
      cli_name: state.cli_name.value,
      cli_middle_name: state.cli_middle_name.value,
      cli_surname: state.cli_surname.value,
      cli_surname2: state.cli_surname2.value,
      cli_country: state.cli_country.value.iso_code,
      cli_email: this.normalizeText(state.cli_email.value),
      cli_email2: this.normalizeText(state.cli_email2.value),
      agent_email,
      // Replace all currencies (/g) of spaces (/s+) by empty space ('')
      cli_phone: state.cli_phone.value.replace(/\s+/g, ''),
      cli_address: state.cli_address.value || '',
      cli_city: state.cli_city.value || '',
      cli_postal_code: state.cli_postal_code.value || '',
      cli_add_member: loyalty && loyalty.selectedStatus
        ? loyalty.selectedStatus === LOYALTY_STATUS.BECOME_MEMBER : false,
      cli_code: cardCode,
      cli_membership_name: this.props.loyaltyUser ? this.props.loyaltyUser.membership_name : '',
      agent_code: agentCode,
      book_comments: state.book_comments.value,
      rate_type: this.props.rateType,
      book_arrival_time: state.book_arrival_time.value.code,
      payment_method: state.paymentMethod.value,
      // TEMA VisualicacionTarifasEnDiversasCurrenciesParaCallCenter
      // Se pidió que los usuarios de call center puedan filtrar por varias currencies
      // para ver visualmente los montos. Anteriormente cuando el usuario de call center
      // filtraba por algún currency, también con eso se seteaba ese currency como
      // el payment currency.
      /*book_user_currency: session.user && isCallCenterUser
        ? this.props.filterCurrency.code : this.props.hotel.default_currency,*/
      book_user_currency,
      book_payment_currency,
      cli_newsletter: state.newsletter.value,
      send_payment_email: state.sendPaymentEmail || false,
      call_center_email: session.user && isCallCenterUser ? session.user.email : '',
      ...cardDetails,
      ...loyaltyDetails,
    });
  }

  /** BLOCK: Validates ****************************************************************************** */
  validateConfirmEmail() {
    const email = this.normalizeText(this.state.cli_email.value);
    const emailConfirm = this.normalizeText(this.state.cli_email2.value);

    // When a value is entered and the mails do not match, we update the confirmEmail error
    if (emailConfirm === '' || email !== emailConfirm) {
      return {
        valid: false,
        msg: this.context.t('Please, make sure both emails are the same.'),
      };
    }
    return { valid: true, msg: '' };
  }

  async validateEmail() {
    // To validate the main email, we need to cross-validate the confirmation email field
    // The error is always set on the confirmation email field
    const { cli_email, cli_email2 } = this.state;
    const email = this.normalizeText(cli_email.value);
    const emailConfirm = this.normalizeText(cli_email2.value);

    let emailValidation = { valid: true, msg: '' };
    let emailConfirmValidation = { valid: true, msg: '' };

    // In case the confirmation email does not match the main one, we update the confirmation email error
    if (email !== emailConfirm) {
      emailConfirmValidation = {
        valid: false,
        msg: this.context.t('Please, make sure both emails are the same.'),
      };
    }
    let emailGramaticallyCorrect = true;
    // For the main email, we add the validation that it is a valid email
    if (email === '' || !/^\S+@(\S{2,})\.((.+){2,})$/.test(email)) {
      emailGramaticallyCorrect = false;
      emailValidation = {
        valid: false,
        msg: this.context.t('Please review your e-mail address'),
      };
    }

    // Update the state of the other field, so that they are not out of sync
    this.setState({
      [FIELDS.CLI_EMAIL2]: {

        ...cli_email2,
        ...emailConfirmValidation,
      },
    });

    if (emailGramaticallyCorrect === true) {
      const shouldValidateEmail = this.props.session.chainData.email_validation_on_creating_bookings_enabled
      && this.props.hotel.email_validation_on_creating_bookings_enabled;
      // Hacer la validación del correo acá
      const validEmailToEmailValidator = await this.props.validateEmailToEmailValidator(email,
        shouldValidateEmail,
      );
      if (validEmailToEmailValidator === false) {
        emailValidation = {
          valid: false,
          msg: this.context.t('Please enter a valid email.'),
        };
      }
      // Hacer la validación del correo acá
    }

    const stateForAgentCode = store.getState();
    const agentCodeEnteredInBookingForm = stateForAgentCode.booking.agentCode;
    const agentSellEnteredInBookingForm = stateForAgentCode.booking.agentSell;
    if (agentCodeEnteredInBookingForm !== '' && agentSellEnteredInBookingForm === 'true') {
      //Cuando agentSell es 'true' logeamos por debajo al usuario del cliente
      //para poder asociar la booking. Cuando cambian el correo debemos hacer logout
      //porque después pueden meter algún correo que no esté en loyalty
      /*this.props.logout();
      this.checkMember(email);*/
      //Cuando es un agente y ese agente vende a otros clientes (agentSell=true)
      //consumimos a getMemberInfo para indicar visualmente si el cliente
      //ya es miembro de loyalty o todavía no.
    }
    this.setState({
      [FIELDS.CLI_EMAIL]: {

        ...cli_email,
        ...emailValidation,
      },
    });

    // Finally, return the state update for the current field
    return emailValidation;
  }

  validateExpiryFields(field, updatedValue) {
    const state = { valid: true, msg: '' };
    const month = field === 'card_expiration_month'
      ? updatedValue
      : this.state.card_expiration_month.value;
    const year = field === 'card_expiration_year'
      ? updatedValue
      : this.state.card_expiration_year.value;
    if (month && year) {
      const lastDay = month.code === 2 ? 28 : 30;
      const expiryDate = new Date(year.code, month.code, lastDay);
      if (expiryDate.getTime() < new Date().getTime()) {
        state.valid = false;
        state.msg = this.context.t('This card has expired');
      }
    }
    return state;
  }

  async validateFormField(fieldName, newValue) {
    const { card_type, card_number } = this.state;
    const {
      BOOK_CONDITIONS,
      CLI_CODE,
      CLI_SURNAME,
      CLI_SURNAME2,
      CARD_HOLDER,
      CLI_NAME,
      CLI_MIDDLE_NAME,
      CLI_EMAIL,
      CLI_EMAIL2,
      CLI_PHONE,
      AGENT_CODE,
    } = FIELDS;
    // Special fields use their own validation
    if (fieldName === BOOK_CONDITIONS) {
      const isValid = !!newValue; // This checkbox is required, so let's verify it was checked
      return {
        valid: isValid,
        msg: isValid
          ? ''
          : this.context.t('Please accept Terms and Conditions'),
      };
    }
    if (fieldName === CLI_CODE) {
      return this.validateLoyaltyCode(newValue);
    }
    // Temporary block due to ticket: #108162
    if (fieldName === AGENT_CODE) {
      return this.validateAgentField(newValue);
    }
    const stateForAgentCode = store.getState();
    const agentCodeEnteredInBookingForm = stateForAgentCode.booking.agentCode;

    if (fieldName === CLI_PHONE) {
      if (agentCodeEnteredInBookingForm === '') {
        return this.validatePhoneNumber(newValue);
      }
      //If it is an agentCode, whe return valid true
      const phone_validate_state = { valid: true, msg: '' };
      return phone_validate_state;
    }

    if (card_number.value && card_type.value.validation_code) {
      const isCardValid = card.isValid(
        card_number.value,
        card_type.value.validation_code,
      );
      const cardNumberInvalidMsg = this.context.t('Card Number Invalid');
      const cardTypeInvalidMsg = this.context.t('Card Type Invalid');
      const updatedCardNumberState = {
        valid: isCardValid,
        msg: isCardValid ? '' : cardNumberInvalidMsg,
      };
      const updatedCardTypeState = {
        valid: isCardValid,
        msg: isCardValid ? '' : cardTypeInvalidMsg,
      };
      this.setState({
        card_number: { ...card_number, ...updatedCardNumberState },
        card_type: { ...card_type, ...updatedCardTypeState },
      });
    }

    // FormControl / input fields are validated through HTML5 validation, plus additional business rules verification
    // eslint-disable-next-line react/no-string-refs
    const formField = this.refs.confirmForm.elements[`inp_${fieldName}`];
    const state = { valid: true, msg: '' };
    if (!formField.checkValidity()) {
      state.valid = false;
      const validationState = formField.validity;
      const fieldLabel = this.label(fieldName);
      if (validationState.valueMissing) {
        state.msg = this.context.t('{fieldName} is a required field', {
          fieldName: fieldLabel,
        });
      } else if (validationState.tooShort) {
        state.msg = this.context.t(
          '{fieldName} should be at least {length} characters long',
          { fieldName: fieldLabel, length: formField.minLength },
        );
      } else if (validationState.tooLong) {
        state.msg = this.context.t(
          '{fieldName} must be {length} characters long at most',
          { fieldName: fieldLabel, length: formField.maxLength },
        );
      } else if (validationState.patternMismatch) {
        state.msg = this.context.t('Incorrect data, check the {fieldName}', {
          fieldName: fieldLabel,
        });
      } else if (validationState.typeMismatch) {
        state.msg = this.context.t(
          'Please, review this field. Incorrect format.',
        );
      }
    } else if (fieldName === CLI_EMAIL) {
      return this.validateEmail();
    } else if (fieldName === CLI_EMAIL2) {
      return this.validateConfirmEmail();
    } else if (
      fieldName === CLI_NAME
            || fieldName === CLI_MIDDLE_NAME
            || fieldName === CLI_SURNAME
            || fieldName === CLI_SURNAME2
            || fieldName === CARD_HOLDER
    ) {
      return this.validateNameFields(fieldName);
    }
    return state;
  }

  validateNameFields(fieldName) {
    const field = this.state[fieldName];
    // Remove the whitespaces at the start and the end of the string.
    const trimmedValue = field.value.trim();
    if (trimmedValue) {
      const onlyValidChars = /^[^#$%^@`\[\]!¡¿?,><;+*|/&%{}_\/~]*$/; // eslint-disable-line no-useless-escape
      if (!onlyValidChars.test(trimmedValue)) {
        return {
          valid: false,
          msg: this.context.t(
            "Check this field. Don't use numbers or special characters.",
            { fieldName },
          ),
        };
      }
    }
    return { valid: true, msg: '' };
  }

  validatePhoneNumber(number) {
    // Si no empieza con '+', se lo agrega
    // Fue necesario hacer ésto porque en el escenario de
    // agentSell="true" salía ese error de que no estaba bien
    // el número de teléfono y es porque le falta el +
    let numberToValidate = number;
    if (!numberToValidate.startsWith('+')) {
      numberToValidate = `+${numberToValidate}`;
    }
    const validPhone = /^\+[0-9]{6,15}$/;
    // inside the ValidPhone.test() Expression: Replace all currencies (/g) of spaces (/s+) by empty space ('')
    const isStateValid = numberToValidate != null
      ? validPhone.test(numberToValidate.replace(/\s+/g, ''))
      : false;
    const state = { valid: isStateValid, msg: '' };
    if (!state.valid) {
      state.msg = this.context.t('Please review your phone number');
    }
    return state;
  }

  /** END BLOCK: Validates ************************************************************************** */
}

ConfirmForm.propTypes = {
  paymentMethods: PropTypes.array.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  forwardedRef: PropTypes.object, // PropType para la referencia pasada por forwardRef
  navigate: PropTypes.func.isRequired, // PropType para `navigate`
};

ConfirmForm.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  hotel: state.booking.hotel,
  lang: state.i18nState.lang,
  filterCurrency: state.booking.filterCurrency,
  paymentCurrency: state.booking.paymentCurrency,
  chain: state.bookingFormState.chain,
  cart: state.cart,
  cartHotel: state.cart.cartHotel,
  default_confirm_country: state.cart.default_confirm_country,
  isFreeModeSelected: state.bookingFormState.isFreeModeSelected,
  lastRequestedInfo: state.booking.last_requested_info,
  loyaltyName: state.session.chainData.booking_engine_configuration.loyalty_name,
  loyaltyEnabled: state.session.chainData.booking_engine_configuration.loyalty_active,
  loyaltyUser: state.loyalty.loggedUser,
  loyaltyMemberInfo: state.loyalty.memberInfo,
  isCallCenterUser: state.session.user.role === CALL_CENTER_ROLE,
  loyalty: state.loyalty,
  session: state.session,
  isCreatingBooking: state.session.isCreatingBooking,
  isMobile: state.booking.device === DEVICES.MOBILE,
  isTabletV: state.booking.device === DEVICES.TABLETV,
  isTabletH: state.booking.device === DEVICES.TABLETH,
  isDesktop: state.booking.device === DEVICES.DESKTOP,
  showLastChanceToRegister: state.loyalty.showLastChanceToRegister,
  lastChanceRegisterConfirmed: state.loyalty.lastChanceRegisterConfirmed,
  isLoyaltyUserLoggedIn: state.loyalty.memberInfo ? !!state.loyalty.memberInfo.email : false,
  selectedStatus: state.loyalty.selectedStatus,
  isEditingBooking: state.booking.isEditingBooking,
  bookingContactInformationHasBeenEdited: state.booking.bookingContactInformationHasBeenEdited,
  locator: state.booking.book_locator,
  email: state.booking.book_email,
  isInBookingDetailsPage: window.location.pathname.includes('/thanks/')
    || window.location.pathname.includes('/my-booking/')
    || window.location.pathname.includes('/booking-detail/'),
  optinAccepted: state.loyalty.optinAccepted,
  agentCode: state.bookingFormState.agentCode,
  agentSell: state.bookingFormState.agentSell,
  callCenterCustomerCode: state.session.callCenterCustomerCode,
  rateType: state.booking.rateType,
  agentUseCoins: state.booking.agentUseCoins,
});

const mapDispatchToProps = (dispatch) => ({
  bookingConfirm: (context, payload, navigate, book_locator, book_email) =>
    dispatch(bookingConfirm(context, payload, navigate, book_locator, book_email)),
  bookingSaveContactInfo: (context, payload, navigate, locator) =>
    dispatch(bookingSaveContactInfo(context, payload, navigate, locator)),
  setShowEditBookingContactInformation: (show) =>
    dispatch(setShowEditBookingContactInformation(show)),
  setBookingContactInformationHasBeenEdited: (edited) =>
    dispatch(setBookingContactInformationHasBeenEdited(edited)),
  checkCustomerValid: (payload) => dispatch(checkCustomerValid(payload)),
  clearRoomSelection: (payload) => dispatch(clearRoomSelection(payload)),
  emptyShoppingCart: (payload) => dispatch(emptyShoppingCart(payload)),
  getCountries: (payload) => dispatch(getCountries(payload)),
  setMemberInfo: (payload) => dispatch(setMemberInfo(payload)),
  setLoggedUser: (payload) => dispatch(setLoggedUser(payload)),
  setCoinsApplied: (payload) => dispatch(setCoinsApplied(payload)),
  setCoinsEntered: (payload) => dispatch(setCoinsEntered(payload)),
  sendBudgetEmail: (payload) => dispatch(sendBudgetEmail(payload)),
  setCurrencies: (payload) => dispatch(setCurrencies(payload)),
  validateEmailToEmailValidator: (email, validation_enabled) =>
    dispatch(validateEmailToEmailValidator(email, validation_enabled)),
  setUserCurrency: (payload) => dispatch(setUserCurrency(payload)),
  setCreatingBooking: (payload) => dispatch(setCreatingBooking(payload)),
  getMemberInfo: (payload) => dispatch(getMemberInfo(payload)),
  setAgentCode: (payload) => dispatch(setAgentCode(payload)),
  setAgentSell: (payload) => dispatch(setAgentSell(payload)),
  setRateType: (payload) => dispatch(setRateType(payload)),
  setAgentUseCoins: (payload) => dispatch(setAgentUseCoins(payload)),
  logout: (payload) => dispatch(logout(payload)),
  setShowLastChanceToRegister: (show) => dispatch(setShowLastChanceToRegister(show)),
  setLastChanceRegisterConfirmed: (show) => dispatch(setLastChanceRegisterConfirmed(show)),
  getBookingDetail: (lang, locator, email) => dispatch(getBookingDetail(lang, locator, email)),
});

const ConnectedChildComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConfirmForm);

// Envuelve el componente con withNavigate y luego con forwardRef
const ConfirmFormWithNavigate = withNavigate(ConnectedChildComponent);

const ForwardedConfirmForm = forwardRef((props, ref) => (
  <ConfirmFormWithNavigate {...props} forwardedRef={ref} />
));

ForwardedConfirmForm.displayName = 'ForwardedConfirmForm';

export default ForwardedConfirmForm;
